// Flag to prevent duplicate webhook calls
let pointsBalanceWebhookTriggered = false;
let voucherListAccountWebhookTriggered = false;

$(function() {  
  // Remove return_url query parameter from /account/register URL
  if (window.location.pathname === '/account/register' && window.location.search === '?return_url=%2Faccount') {
    window.location.replace('/account/register');
    return;
  }

  // Check if voucher was just redeemed successfully (after page reload)
  if (sessionStorage.getItem('voucherRedeemSuccess') === 'true') {
    sessionStorage.removeItem('voucherRedeemSuccess');
    // Small delay to ensure page is fully loaded
    setTimeout(() => {
      showVoucherSuccessNotification('Voucher redeemed successfully!');
    }, 500);
  }
  
  removeComplimentarySamples();
  removePWP();
  addGWP();
  updateGWP();
  removeGWP();
  initFlickityaddress();
  stickytopheight();
  equalizeAddressTitles();
  window.addEventListener('resize', stickytopheight);
  window.addEventListener('scroll', stickytopheight);
  window.addEventListener('resize', equalizeAddressTitles);
  
  // Trigger voucher list account webhook check (fallback in jQuery ready)
  checkAndTriggerVoucherListAccountWebhook();

  // Global function to rerender the minimuse section
  // Can accept section HTML directly (faster) or fetch it if not provided
  window.rerenderMinimuseSection = function(sectionHtml) {
    // Find the minimuse section container
    var $minimuseContainer = $('.minimuse-product-main-container');
    if ($minimuseContainer.length === 0) {
      return;
    }
    
    // Get the section element
    var sectionElement = $minimuseContainer.closest('.shopify-section')[0];
    if (!sectionElement) {
      return;
    }
    
    // Extract section ID
    var sectionId = sectionElement.id.replace('shopify-section-', '');
    if (!sectionId) {
      return;
    }
    
    // If section HTML is provided, use it directly (faster)
    if (sectionHtml) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionHtml, 'text/html');
      var newSection = doc.querySelector('.shopify-section');
      
      if (newSection) {
        // Replace the section content
        sectionElement.replaceChildren(...document.importNode(newSection, true).childNodes);
        
        // Reinitialize any JavaScript that might be needed
        if (typeof window.initMinimuseSection === 'function') {
          window.initMinimuseSection();
        }
        
        // Reinitialize pagination after section rerender
        setTimeout(function() {
          initMinimusePagination();
        }, 100);
      }
      return;
    }
    
    // Otherwise, fetch the section HTML (fallback)
    var sectionUrl = window.location.pathname + '?section_id=' + sectionId;
    fetch(sectionUrl)
      .then(response => response.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('.shopify-section');
        
        if (newSection) {
          // Replace the section content
          sectionElement.replaceChildren(...document.importNode(newSection, true).childNodes);
          
          // Reinitialize any JavaScript that might be needed
          if (typeof window.initMinimuseSection === 'function') {
            window.initMinimuseSection();
          }
          
          // Reinitialize pagination after section rerender
          setTimeout(function() {
            initMinimusePagination();
          }, 100);
        }
      })
      .catch(error => {
        console.error('Error rerendering minimuse section:', error);
      });
  };

  document.documentElement.addEventListener('cart-drawer:refreshed', function() {
    // Rerender minimuse section to update pouchselected state
    window.rerenderMinimuseSection();
    // The lock is NOT taken and released around this block. These calls are
    // asynchronous, so the old `disableCartBtn(); ...; enableCartBtn();` pair
    // released checkout immediately, while the mutations it was meant to guard
    // were still in flight. beginCartWork()/endCartWork() bracket the real work
    // instead; here we only re-apply a lock the re-render just discarded.
    restoreCheckoutBusyState();
    removeComplimentarySamples();
    removePWP();
    addGWP();
    updateGWP();
    removeGWP();
    // The pass has had its say. If it started a mutation it holds its own
    // reference, so checkout stays locked until that settles.
    releaseUserChangeLock();
  });
  
  // Also listen for cart:refresh event to rerender section
  document.documentElement.addEventListener('cart:refresh', function() {
    // Rerender immediately - no delay needed
    window.rerenderMinimuseSection();
  });

  // Dispatched by theme.js before the /cart/change request goes out, so this is
  // the earliest point the UI can react to a quantity change or a removal.
  // Changing a qualifying line can retire the gifts it earned, so those are
  // marked provisional too — dimmed, never hidden, because a gift that still
  // qualifies must not flicker out and back in.
  document.documentElement.addEventListener('line-item:will-change', function(evt) {
    var lineItem = evt.target && evt.target.closest ? evt.target.closest('line-item') : null;
    if (!lineItem) {
      return;
    }

    // A fresh user action restarts the convergence budget.
    cartSyncPasses = 0;

    // Lock checkout now, not when the GWP pass eventually starts.
    acquireUserChangeLock();

    var scope = cartRowScope(lineItem);
    scope.classList.add('is-busy');
    if (!isGiftRow(scope)) {
      markGiftLinesBusy();
    }
  });

  // theme.js asks which other lines must retire alongside the one being changed.
  document.documentElement.addEventListener('cart:collect-dependent-lines', function(evt) {
    var detail = evt.detail;
    if (!detail || !detail.lines) {
      return;
    }

    dependentGiftLines(detail.lineKey, detail.targetQuantity).forEach(function(key) {
      detail.lines.add(key);
    });
  });

  // theme.js asks which sections to bundle with the cart mutation. The cart drawer
  // adds itself; on the cart page nothing did, which is why that page could only
  // reload. Adding main-cart here means the fresh markup rides back on the same
  // response — no extra request.
  document.documentElement.addEventListener('cart:prepare-bundled-sections', function(evt) {
    var section = cartSectionElement();
    if (section && evt.detail && evt.detail.sections) {
      evt.detail.sections.add(section.id.replace('shopify-section-', ''));
    }
  });

  document.documentElement.addEventListener('cart:change', function(evt) {
    var section = cartSectionElement();
    if (!section) {
      return;
    }

    var sectionId = section.id.replace('shopify-section-', '');
    var sections = evt.detail && evt.detail.cart ? evt.detail.cart.sections : null;

    // Fall back to fetching if the section did not ride along, so the cart page
    // never sits stale after a change.
    if (!sections || !swapCartSection(sections[sectionId], sectionId)) {
      // A bundled section that comes back null means this environment cannot
      // render sections at all (`shopify theme dev` behaves this way), so don't
      // spend a round trip discovering that again via ?section_id=.
      if (sections && sections[sectionId] === null) {
        sectionRenderingAvailable = false;
      }
      refreshCartSection();
    }
  });

  // Always hide Gorgias Chat "Need more help?" at start
  localStorage.setItem('gorgas.floating-chat-input-next-display-time', new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString());
  
  // Get the loyalty number from the data attribute dynamically
  const container = document.getElementById('barcode-container');
  const loyaltyNumber = container ? container.getAttribute('data-loyalty-number') : null;
  
  if (loyaltyNumber) {
    console.log('Loyalty number found:', loyaltyNumber);
    // Wait for QRCode library to be loaded before generating QR code
    waitForQRCodeLibrary(() => {
      console.log('QRCode library loaded, generating QR code...');
      generateWalletBarcode(loyaltyNumber, "barcode-container");
    });
  } else {
    console.log('No loyalty number found in container');
  }
  
  // Generate QR codes for voucher codes on first load
  waitForQRCodeLibrary(() => {
    generateVoucherQRCodes();
  });
  
  // Initialize voucher popup functionality
  initVoucherPopup();
  
  // Check for first login parameter and handle accordingly
  checkFirstLogin();
});

/**
 * Check for firstlogin=true URL parameter and handle loading/reload logic
 */
function checkFirstLogin() {
  // Check if URL contains /account?firstlogin=true
  const isAccountPage = window.location.pathname.includes('/account');
  const urlParams = new URLSearchParams(window.location.search);
  const firstLogin = urlParams.get('firstlogin');
  
  if (isAccountPage && firstLogin === 'true') {
    // Check if customerData email and walletId are empty
    const hasEmptyData = !window.customerData || 
                        !window.customerData.email || 
                        !window.customerData.walletId ||
                        window.customerData.email === '' ||
                        window.customerData.walletId === '';
    
    if (hasEmptyData) {
      // Show full page loading overlay
      showFirstLoginOverlay();
      
      // Wait 20 seconds then reload
      setTimeout(function() {
        window.location.reload();
      }, 10000);
    } else {
      // Data exists, remove firstlogin parameter from URL
      removeFirstLoginFromUrl();
    }
  }
}

/**
 * Show full page loading overlay for first login
 */
function showFirstLoginOverlay() {
  let loadingOverlay = document.getElementById('first-login-loading-overlay');
  if (!loadingOverlay) {
    loadingOverlay = document.createElement('div');
    loadingOverlay.id = 'first-login-loading-overlay';
    loadingOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      pointer-events: auto;
    `;
    loadingOverlay.innerHTML = `
      <div class="first-login-loading-spinner" style="
        width: 50px;
        height: 50px;
        border: 5px solid rgba(255, 255, 255, 0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: first-login-spin 0.8s linear infinite;
      "></div>
    `;
    
    // Add spinner animation if not already added
    if (!document.getElementById('first-login-spinner-styles')) {
      const style = document.createElement('style');
      style.id = 'first-login-spinner-styles';
      style.textContent = `
        @keyframes first-login-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(loadingOverlay);
  }
  // Ensure overlay is visible
  loadingOverlay.style.display = 'flex';
  loadingOverlay.style.visibility = 'visible';
  loadingOverlay.style.opacity = '1';
}

/**
 * Remove firstlogin parameter from URL without reloading
 */
function removeFirstLoginFromUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('firstlogin');
  
  // Update URL without reloading
  window.history.replaceState({}, '', url.toString());
}

// start: complimentary samples
function removeComplimentarySamples() {
  var $cartDrawer = $('.jsc-cart-drawer-body');
  var $cartItems = $cartDrawer.find('.line-item');
  var onlyHasSamples = true;
  var hasMetroDelivery = false;
  var removeKeyList = {};
  
  $cartItems.each(function() {
    var isComplimentarySample = $(this).attr('is-complimentary-sample');
    var isMetroDelivery = $(this).attr('metro-delivery');

    if (isComplimentarySample == undefined) {
      onlyHasSamples = false;
      var isMetroDelivery = $(this).attr('metro-delivery');
      if (isMetroDelivery != undefined) {
        hasMetroDelivery = true;
      }
    }
  });

  if (onlyHasSamples || hasMetroDelivery == false) {
    $cartItems.each(function() {
      var key = $(this).attr('data-key');
      var isComplimentarySample = $(this).attr('is-complimentary-sample');

      if (isComplimentarySample != undefined) {
        removeKeyList[key] = 0;
      }
    });

    if (Object.keys(removeKeyList).length > 0) {
      cartJSUpdateQuantity(removeKeyList);
    }
  }
}
// end: complimentary samples

// start: pwp
function removePWP() {
  var $cartDrawer = $('.jsc-cart-drawer-body');
  var cartTotalNoPWP = parseInt($cartDrawer.attr('cart-total-exclude-pwp'));
  var pwpMinSpend = parseInt($cartDrawer.attr('pwp-min-spend'));
  
  if (cartTotalNoPWP < pwpMinSpend) {
    var $cartItems = $cartDrawer.find('.line-item');
    var removeKeyList = {};
    $cartItems.each(function() {
      var key = $(this).attr('data-key');
      var isPWP = $(this).attr('is-pwp');

      if (isPWP != undefined) {
        removeKeyList[key] = 0;
      }
    });

    if (Object.keys(removeKeyList).length > 0) {
      cartJSUpdateQuantity(removeKeyList);
    }
  }
}

// pwp banner ATC
window.pwpATC = function(evt) {
  var id = parseInt($(evt).attr('variant-id'));
  var items = [];
  var pwpItem = {
    'id': id,
    'quantity': 1,
    'properties': {'_PWP': 'Yes'}
  };
  items.push(pwpItem);
  cartJSAddQuery(items);
}
// end: pwp

// start: cart mutations
// ---------------------------------------------------------------------------
// These were CartJS calls whose success handler then went and fetched the cart
// markup separately — so every gift add or removal cost a mutation AND a whole
// extra render, the render being by far the expensive half.
//
// Now the mutation asks Shopify to return the re-rendered section in the SAME
// response, and the result is dispatched as `cart:change`. That is the event the
// theme already uses to re-render from a payload: the native cart drawer handles
// it, and so does the cart page listener. One request, no follow-up fetch.
//
// A true single-request ADD is not possible: gift lines need properties, only
// /cart/add.js can set them, and it cannot also change another line's quantity.
// The add stays its own request — but it no longer drags a second render with it.

// Collects the sections worth re-rendering for whichever cart surface is on screen.
function bundledSectionsForCart() {
  var sections = new Set();
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections: sections }
  }));
  return Array.from(sections);
}

// addGWP / updateGWP / removeGWP all fire within one pass. Left unsequenced they
// race: concurrent mutations carry line keys read from the same render, so the
// second one can reference a line the first already changed — observed as a 422,
// and as two gift rows on screen at once mid-flight.
//
// So mutations are chained, and the re-render is dispatched ONCE when the whole
// batch has drained rather than after each call.
var gwpChain = Promise.resolve();
var gwpPending = 0;
var gwpLatestCart = null;

function gwpMutate(endpoint, payload) {
  gwpPending++;

  gwpChain = gwpChain
    .then(function() {
      return runCartMutation(endpoint, payload);
    })
    .then(function(cart) {
      if (cart) {
        gwpLatestCart = cart;
      }
    })
    .catch(function(err) {
      console.log('Error occur !', err && err.message);
    })
    .then(function() {
      gwpPending--;

      if (gwpPending === 0 && gwpLatestCart) {
        var cart = gwpLatestCart;
        gwpLatestCart = null;

        // Everything downstream — drawer swap, cart page swap, cart count —
        // already listens for this. Deliberately NOT cart:refresh: that is what
        // triggers the native drawer's full-page fetch we are avoiding.
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'gwp:sync', cart: cart }
        }));

        var $cartDrawer = $('#cart-drawer')[0];
        if ($cartDrawer && !$cartDrawer.hasAttribute('open')) {
          $cartDrawer.show();
        }
      }

      endCartWork();
    });

  return gwpChain;
}

function runCartMutation(endpoint, payload) {
  var sections = bundledSectionsForCart();
  if (sections.length > 0) {
    payload.sections = sections.join(',');
    payload.sections_url = window.location.pathname;
  }

  return fetch(Shopify.routes.root + endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(function(response) {
      return response.json().then(function(body) {
        return { ok: response.ok, body: body };
      });
    })
    .then(function(result) {
      if (!result.ok) {
        // A stale line key returns 422. Log and carry on: the next render is
        // authoritative and will re-issue anything still outstanding.
        console.log('Error occur !', result.body && result.body.description);
        return null;
      }

      // /cart/update.js returns the cart. /cart/add.js returns only the added
      // items, so the cart has to be read for the item count — but the sections
      // still ride on the add response, so no extra render is needed.
      if (endpoint.indexOf('add.js') !== -1) {
        return fetch(Shopify.routes.root + 'cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            cart.sections = result.body.sections;
            return cart;
          });
      }
      return result.body;
    });
}

// `updates` is keyed by LINE KEY. The previous implementation ran the keys through
// parseInt first, which silently truncated "44523895423:1c2a9f..." to the leading
// variant id — so removing a gift also zeroed a paid line of the same variant.
function cartJSUpdateQuantity(updates) {
  gwpMutate('cart/update.js', { updates: updates });
}

function cartJSAddQuery(items) {
  gwpMutate('cart/add.js', { items: items });
}
// end: cart mutations

// Start: Brand page
window.brandAnchor = function(evt) {
  var link = $(evt).attr('href');
  var $anchor = $(`.section-brand-list .jsc-brand-list-wrap[anchor-link="${link}"]`);

  console.log(link)
  if ($anchor.length > 0) {
      $('html, body').animate({
          scrollTop: $anchor.offset().top - 275
      }, 500);
  }
}

window.filterBrand = function(evt) {
  var value = $(evt).val();
  var $brandListSection = $('.section-brand-list');
  var $brand = $brandListSection.find('.jsc-brand');
  var $brandListWrap = $brandListSection.find('.jsc-brand-list-wrap');

  if (value == 'all') {
      $brand.removeClass('hide');
  }
  else {
      $brand.each(function() {
          var category = $(this).attr('category');
          if (category == value) {
              $(this).removeClass('hide');
          }
          else {
              $(this).addClass('hide');
          }
      });
  }

  $brandListWrap.each(function() {
      var $visibleBrand = $(this).find('.jsc-brand:not(.hide)');
      if ($visibleBrand.length > 0) {
          $(this).removeClass('hide');
      }
      else {
          $(this).addClass('hide');
      }
  });
}
// End: Brand page

// Start: Cart pending state
// ---------------------------------------------------------------------------
// The GWP engine is a second pass: Liquid decides, JS mutates the cart, the cart
// re-renders. Between those steps the cart on screen is stale but still looks
// final, which is what reads as lag. These helpers mark the affected rows as
// provisional immediately, and drive the theme's existing loading-bar so the
// recalculation is acknowledged instead of happening silently.
var cartWorkDepth = 0;
var userChangeLockHeld = false;
var userChangeLockTimer = null;

// The two cart surfaces disagree about what a row is. In the drawer one
// <line-item> is the whole row. On the cart page a row is a <tr> split across
// cells: the keyed <line-item>, a second bare <line-item> holding the quantity
// selector and remove link, and the price. Resolve to whichever is the real row,
// or the cart page dims half of it.
function cartRowScope(lineItem) {
  return lineItem.closest('tr') || lineItem;
}

function isGiftRow(scope) {
  return scope.hasAttribute('is-gwp') || scope.querySelector('line-item[is-gwp]') !== null;
}

function markGiftLinesBusy() {
  document.querySelectorAll('line-item[is-gwp]').forEach(function(line) {
    cartRowScope(line).classList.add('is-busy');
  });
}

function clearCartLinesBusy() {
  document.querySelectorAll('line-item.is-busy, tr.is-busy').forEach(function(row) {
    row.classList.remove('is-busy');
  });
}

// loading-bar keeps no count of its own, so overlapping GWP passes would leave it
// stranded mid-sweep. Balance start/end against a depth counter instead.
function beginCartWork() {
  markGiftLinesBusy();

  if (cartWorkDepth === 0) {
    setCheckoutBusy(true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
  }
  cartWorkDepth++;
}

// Only the last outstanding pass releases the lock. Overlapping passes would
// otherwise unlock checkout while a sibling mutation was still running.
function endCartWork() {
  if (cartWorkDepth === 0) {
    return;
  }

  cartWorkDepth--;
  if (cartWorkDepth === 0) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    clearCartLinesBusy();
    setCheckoutBusy(false);
  }
}
// End: Cart pending state

// Start: Single-pass GWP removal
// ---------------------------------------------------------------------------
// Each GWP engine publishes a small state block describing what its gifts depend
// on. That lets us answer, at the instant the customer clicks, "which gifts can
// this cart no longer support?" — and hand those line keys to theme.js so they are
// retired in the SAME request as the change that caused it.
//
// Before this, gift removal was a second pass: change the cart, re-render, let
// Liquid notice the gift no longer qualifies, fire a second mutation, re-render
// again. Measured on the cart page, that was ~11s end to end locally, and the gift
// stayed on screen for all of it.
//
// The prediction is intentionally conservative. Liquid remains the source of truth;
// anything predicted wrong is corrected by the very response this request returns,
// so a miss costs nothing beyond the old behaviour.

function readGwpState() {
  var blocks = document.querySelectorAll('script.jsc-gwp-state');
  var out = [];

  for (var i = 0; i < blocks.length; i++) {
    try {
      out.push(JSON.parse(blocks[i].textContent));
    } catch (err) {
      // A malformed block must never break the cart; just skip it.
    }
  }
  return out;
}

// "key~linePrice~quantity|key~linePrice~quantity|"
function parseQualifying(str) {
  return String(str || '')
    .split('|')
    .filter(Boolean)
    .map(function(part) {
      var bits = part.split('~');
      var qty = parseInt(bits[2], 10);
      return {
        key: bits[0],
        linePrice: parseInt(bits[1], 10) || 0,
        quantity: qty > 0 ? qty : 1
      };
    });
}

// "giftLineKey~threshold|giftLineKey~threshold|"
function parseGifts(str) {
  return String(str || '')
    .split('|')
    .filter(Boolean)
    .map(function(part) {
      var i = part.lastIndexOf('~');
      return {
        key: i === -1 ? part : part.slice(0, i),
        threshold: i === -1 ? 0 : parseInt(part.slice(i + 1), 10) || 0
      };
    });
}

function dependentGiftLines(lineKey, targetQuantity) {
  var doomed = [];

  readGwpState().forEach(function(campaign) {
    var gifts = parseGifts(campaign.gifts);
    if (gifts.length === 0) {
      return;
    }

    var entry = null;
    parseQualifying(campaign.qualifying).forEach(function(q) {
      if (q.key === lineKey) {
        entry = q;
      }
    });

    // The changed line does not fund this campaign, so its gifts are unaffected.
    if (!entry) {
      return;
    }

    // final_line_price covers the whole line, so scale it to the new quantity.
    var unit = entry.linePrice / entry.quantity;
    var newSubtotal = (campaign.subtotal || 0) - entry.linePrice + Math.round(unit * targetQuantity);

    // Each gift carries the lowest spend that can grant it. Below that, no tier of
    // this campaign can still support it.
    gifts.forEach(function(gift) {
      if (gift.threshold > 0 && newSubtotal < gift.threshold) {
        doomed.push(gift.key);
      }
    });
  });

  return doomed;
}
// End: Single-pass GWP removal

// Start: Cart page in-place refresh
// ---------------------------------------------------------------------------
// The cart page used to reload the whole document after every change: once from
// theme.js on a quantity change, and again from the CartJS callbacks below after
// the GWP pass. Two full reloads to remove one product and its gift. That throws
// away scroll position, re-runs every script on the page, and makes the pending
// state above pointless — the row never animates, the page just blinks.
//
// Instead the main-cart section is re-rendered in place. theme.js already asks
// listeners which sections to bundle and ships them with /cart/change.js, so the
// native path costs no extra request at all; we just stopped throwing the result
// away. The CartJS path (GWP mutations) has no bundling, so it fetches the
// section itself.
var CART_SYNC_PASS_LIMIT = 5;
var cartSyncPasses = 0;
var sectionRenderingAvailable = true;

function cartSectionElement() {
  var host = document.querySelector('.cart');
  return host ? host.closest('.shopify-section') : null;
}

function onCartPage() {
  return cartSectionElement() !== null;
}

// Returns true when the swap happened, so callers can fall back rather than
// silently leaving a stale cart on screen.
function swapCartSection(html, sectionId) {
  var section = cartSectionElement();
  if (!section || typeof html !== 'string' || html.trim() === '') {
    return false;
  }

  var fresh = new DOMParser().parseFromString(html, 'text/html')
    .getElementById('shopify-section-' + sectionId);

  if (!fresh || fresh.innerHTML.trim() === '') {
    return false;
  }

  section.innerHTML = fresh.innerHTML;
  afterCartSectionSwap();
  return true;
}

function afterCartSectionSwap() {
  clearCartLinesBusy();
  // The swap replaced the checkout button along with everything else.
  restoreCheckoutBusyState();
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  // The fresh markup carries a fresh set of GWP instructions. Run them, but bound
  // the chain: a gift Liquid keeps asking for but that cannot be added would
  // otherwise re-render forever. Reset per user action, not per pass.
  if (cartSyncPasses >= CART_SYNC_PASS_LIMIT) {
    console.warn('[cart] GWP sync did not settle after ' + CART_SYNC_PASS_LIMIT + ' passes; stopping.');
    releaseUserChangeLock();
    return;
  }

  cartSyncPasses++;
  addGWP();
  updateGWP();
  removeGWP();
  releaseUserChangeLock();
}

// Used by the CartJS path, which cannot bundle sections. Prefers the Section
// Rendering API and falls back to lifting the section out of the full page —
// section rendering is unavailable through `shopify theme dev`'s proxy, so the
// fallback is what runs locally.
function refreshCartSection(done) {
  var finished = false;
  var finish = function() {
    if (finished) {
      return;
    }
    finished = true;
    if (typeof done === 'function') {
      done();
    }
  };

  var section = cartSectionElement();
  if (!section) {
    finish();
    window.location.reload();
    return;
  }

  var sectionId = section.id.replace('shopify-section-', '');
  var path = window.location.pathname;

  function fullPageFallback() {
    return fetch(path)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var swapped = swapCartSection(html, sectionId);
        finish();
        if (!swapped) {
          window.location.reload();
        }
      });
  }

  // Section rendering is either available in an environment or it is not, so a
  // single failure settles it for the session. Retrying per mutation costs a whole
  // wasted round trip each time — measured at ~1s against `shopify theme dev`,
  // which cannot render sections at all.
  if (!sectionRenderingAvailable) {
    fullPageFallback().catch(function() { finish(); window.location.reload(); });
    return;
  }

  fetch(path + '?section_id=' + encodeURIComponent(sectionId))
    .then(function(response) {
      return response.ok ? response.text() : Promise.reject(new Error(String(response.status)));
    })
    .then(function(html) {
      if (!swapCartSection(html, sectionId)) {
        return Promise.reject(new Error('empty section'));
      }
      finish();
      return true;
    })
    .catch(function() {
      sectionRenderingAvailable = false;
      return fullPageFallback();
    })
    .catch(function() {
      finish();
      window.location.reload();
    });
}
// End: Cart page in-place refresh

// Start: GWP
function addGWP() {
  var $addGWP = $('input[name="jsc-gwp"][jsc-add-gwp]');
  if ($addGWP.length > 0) {
    beginCartWork();
    var items = [];
    $addGWP.each(function() {
      var gwpId = parseInt($(this).attr('gwp-id'));
      var isMinSpendGWP = $(this).attr('min-spend-gwp');
      var isTierGWP = $(this).attr('tier-gwp');
      var fulfilledBy = $(this).attr('gwp-group');
      console.log('fulfilledBy');
      console.log(fulfilledBy);
      var gwpItem = {
        'id': gwpId,
        'quantity': 1,
        'properties': {
          '_GWP': 'Yes',
          '_Fulfilled by': fulfilledBy
        }
      };
      console.log('gwpItem');
      console.log(gwpItem);

      if (isMinSpendGWP != undefined) {
        gwpItem['properties']['_MinSpendGWP'] = 'Yes';
      }
      else if (isTierGWP != undefined) {
        var tierId = $(this).attr('tier-id');
        gwpItem['properties']['_TierGWP'] = 'Yes';
        gwpItem['properties']['_TierIndex'] = isTierGWP;

        // _TierIndex is the metaobject's position in the paginated loop, so it
        // renumbers whenever an entry is drafted or added. _TierId is the entry's
        // handle, which is stable, and is what the Liquid matches on.
        if (tierId != undefined && tierId !== '') {
          gwpItem['properties']['_TierId'] = tierId;
        }
      }

      items.push(gwpItem);
    });

    cartJSAddQuery(items);
  }
}

function updateGWP() {
  var $updateGWP = $('input[name="jsc-gwp"][jsc-update-gwp]');
  if ($updateGWP.length > 0) {
    beginCartWork();
    var updateKeyList = {};
    $updateGWP.each(function() {
      // Line key, NOT parseInt'd: "44523895423:1c2a9f..." truncates to the variant
      // id, which would clamp every line of that variant — including a paid one.
      var gwpKey = $(this).attr('gwp-key');
      updateKeyList[gwpKey] = 1;
    });

    cartJSUpdateQuantity(updateKeyList);
  }
}

function removeGWP() {
  var $removeGWP = $('input[name="jsc-gwp"][jsc-remove-gwp]');
  if ($removeGWP.length > 0) {
    beginCartWork();
    var removeKeyList = {};
    $removeGWP.each(function() {
      // Line key, NOT parseInt'd — see updateGWP above.
      var gwpKey = $(this).attr('gwp-key');
      removeKeyList[gwpKey] = 0;
    });

    cartJSUpdateQuantity(removeKeyList);
  }
}

// Locks checkout while a GWP mutation is in flight, so a customer cannot pay for a
// cart whose gift is still being added or removed.
//
// The two surfaces need different mechanisms: the drawer's control is an <a>, which
// cannot carry `disabled`, so it gets a click preventer plus aria-disabled; the cart
// page's is a real <button>. Both get a class so the block is visible — a control
// that silently swallows clicks reads as a broken site, which was the behaviour
// before this.
//
// The click handler is namespaced. The previous version bound with `.on('click')`
// and released with `.off('click')`, which stacked a new handler on every pass and
// then tore off every click handler on that anchor, including ones bound elsewhere.
function setCheckoutBusy(busy) {
  var $drawerBtn = $('#cart-drawer button-content');
  if ($drawerBtn.length > 0) {
    var $drawerLink = $drawerBtn.parents('a');
    $drawerLink.off('click.gwp');
    if (busy) {
      $drawerLink.on('click.gwp', function(evt) {
        evt.preventDefault();
      });
    }
    $drawerLink
      .toggleClass('is-checkout-busy', busy)
      .attr('aria-disabled', busy ? 'true' : null);
  }

  var $cartPageBtn = $('.cart button[name="checkout"]');
  if ($cartPageBtn.length > 0) {
    $cartPageBtn.prop('disabled', busy).toggleClass('is-checkout-busy', busy);
  }
}

// Holds the lock from the instant the customer acts until the GWP pass that
// follows has had its say.
//
// Without this there is a window — the whole native cart round trip plus re-render,
// measured at ~800ms locally — where the qualifying product is already gone,
// checkout is live, and the gift it earned is still in the cart. The customer sees
// the button go active and the gift disappear a beat later. Taking the lock here
// and releasing it after the pass closes that window: if the pass starts its own
// mutation it takes its own reference, so the lock simply carries through.
function acquireUserChangeLock() {
  if (userChangeLockHeld) {
    return;
  }

  userChangeLockHeld = true;
  beginCartWork();

  // Failsafe: if the pass never runs (a re-render that never lands, a dropped
  // request) the lock must not strand checkout permanently.
  clearTimeout(userChangeLockTimer);
  userChangeLockTimer = setTimeout(function() {
    if (userChangeLockHeld) {
      console.warn('[cart] GWP pass did not report back; releasing checkout lock.');
      releaseUserChangeLock();
    }
  }, 10000);
}

function releaseUserChangeLock() {
  if (!userChangeLockHeld) {
    return;
  }

  userChangeLockHeld = false;
  clearTimeout(userChangeLockTimer);
  userChangeLockTimer = null;
  endCartWork();
}

// Releases the work reference only once the re-render that reflects the mutation
// has actually landed.
//
// Releasing when the request settles is too early: the cart on screen is still
// showing the old contents while the fresh markup is being fetched. Measured on the
// cart page, checkout came back 3.0s before the gift row left the DOM — which is
// exactly the "button went active, then the item vanished" report.
function settleCartWorkAfterRender() {
  if (onCartPage()) {
    refreshCartSection(endCartWork);
    return;
  }

  // In the drawer the re-render is signalled by cart-drawer:refreshed. Guard it
  // with a timeout so a refresh that never lands cannot strand checkout.
  var released = false;
  var timer = null;
  var release = function() {
    if (released) {
      return;
    }
    released = true;
    clearTimeout(timer);
    document.documentElement.removeEventListener('cart-drawer:refreshed', release);
    endCartWork();
  };

  timer = setTimeout(release, 8000);
  document.documentElement.addEventListener('cart-drawer:refreshed', release);

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  var $cartDrawer = $('#cart-drawer')[0];
  if ($cartDrawer && !$cartDrawer.hasAttribute('open')) {
    $cartDrawer.show();
  }
}

// Re-render replaces the checkout control, so a lock taken before the swap is lost
// with the old element. Re-apply it whenever work is still outstanding.
function restoreCheckoutBusyState() {
  if (cartWorkDepth > 0) {
    setCheckoutBusy(true);
  }
}
// End: GWP

// Start: Product Page - to place the size chart beside variant picker
function adjustSizeChartPosition() {
  const container = document.querySelector('.product-info__block-item[data-block-id="variant_picker"]');

  if (!container) return;

  const info = container.querySelector('.variant-picker__option-info');
  const chart = container.querySelector('.ks-chart-container');

  if (info && chart) {
    chart.style.marginLeft = (info.offsetWidth + 14) + "px";
    chart.style.visibility = "visible";
    return true;
  }
  return false;
}

function waitForChart() {
  let attempts = 0;
  const maxAttempts = 100; // 5 seconds max (100 * 50ms)
  
  const interval = setInterval(() => {
    attempts++;
    if (adjustSizeChartPosition() || attempts >= maxAttempts) {
      clearInterval(interval); 
    }
  }, 50);
}
waitForChart();
// End: Product Page - to place the size chart beside variant picker


// Start: Cart gift wrap
window.toggleCartGiftContent = function(evt) {
  var $cartGiftContent = $('.jsc-cart-gift .jsc-cart-gift__content');
  var $giftMessageInput = $cartGiftContent.find('.jsc-cart-gift__message-input');
  var $exchangeReceiptCheck = $cartGiftContent.find('input[name="gift-exchange-receipt-check"]');

  if ($(evt).is(':checked')) {
    $cartGiftContent.removeClass('d-none');
    CartJS.setAttribute('Gift Wrap', 'Yes');
  }
  else {
    $cartGiftContent.addClass('d-none');
    $giftMessageInput.val('');
    $exchangeReceiptCheck.prop('checked', false);
    CartJS.setAttribute('Gift Wrap', null);
    CartJS.setAttribute('Gift Exchange Receipt', null);
    CartJS.setAttribute('Gift Message', null);
  }
}

window.updateExchangeReceiptAttr = function(evt) {
  if ($(evt).is(':checked')) {
    CartJS.setAttribute('Gift Exchange Receipt', 'Yes');
  }
  else {
    CartJS.setAttribute('Gift Exchange Receipt', null);
  }
}

window.updateGiftMessageAttr = function(evt) {
  var giftMessage = $(evt).val().trim();
  if (giftMessage === "") {
    CartJS.setAttribute('Gift Message', null);
  }
  else {
    CartJS.setAttribute('Gift Message', giftMessage);
  }
}
// End: Cart gift wrap
// Start: Account Tab
window.changeTab = function(evt) {
  var $tab = $(evt);
  $tab.parents('.rich-text').find('.active').removeClass('active');
  $tab.addClass('active');
}
window.stickytopheight = function() {
  var $header = $('header');
  var $accountTab = $('.account-tab-section');
  $accountTab.css('--header-height', $header.height() + 'px');
}
window.initFlickityaddress = function() {
  var $addressList = $('.address-list-flickity');
  if ($addressList.length > 0) {
    $addressList.flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      wrapAround: false,
      draggable: true,
      groupCells: true,
      imagesLoaded: true,
      prevNextButtons: false
    });
    
    // Equalize address titles after Flickity is initialized
    setTimeout(function() {
      equalizeAddressTitles();
    }, 100);
  }
}

/**
 * Equalize the height of all address-title elements to match the tallest one
 */
window.equalizeAddressTitles = function() {
  var $addressTitles = $('.address-title');
  
  if ($addressTitles.length > 1) {
    // Reset heights to auto to get natural heights
    $addressTitles.css('height', 'auto');
    
    // Find the maximum height
    var maxHeight = 0;
    $addressTitles.each(function() {
      var height = $(this).outerHeight();
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    // Set all address titles to the maximum height
    $addressTitles.css('height', maxHeight + 'px');
  }
}
// End: Account Tab
// Start: Account bar
/**
 * Show address limit notification popup
 * Informs user they have reached the maximum of 3 addresses and need to remove one to add more
 */
window.showAddressLimitNotification = function() {
  $('.address-limit-notification').show();
  // Auto-hide after 8 seconds
  setTimeout(() => {
    $('.address-limit-notification').hide();
  }, 8000);
}

/**
 * Show voucher error notification popup
 * Displays error message when voucher redemption fails
 */
window.showVoucherErrorNotification = function(message) {
  let $notification = $('.voucher-error-notification');
  if ($notification.length === 0) {
    // Create notification element if it doesn't exist
    $notification = $('<div class="voucher-error-notification"></div>');
    $('body').append($notification);
  }
  // Set message text (preserves ::before pseudo-element)
  $notification.html(message || 'Failed to redeem voucher. Please try again.');
  $notification.show();
  // Auto-hide after 8 seconds
  setTimeout(() => {
    $('.voucher-error-notification').hide();
  }, 8000);
}

window.showVoucherSuccessNotification = function(message) {
  let $notification = $('.voucher-success-notification');
  if ($notification.length === 0) {
    // Create notification element if it doesn't exist
    $notification = $('<div class="voucher-success-notification"></div>');
    $('body').append($notification);
  }
  // Set message text (preserves ::before pseudo-element)
  $notification.html(message || 'Voucher redeemed successfully!');
  $notification.show();
  // Auto-hide after 3 seconds
  setTimeout(() => {
    $('.voucher-success-notification').hide();
  }, 3000);
}
/**
 * Wait for QRCode library to be loaded
 * @param {Function} callback - Function to call when QRCode library is available
 * @param {number} timeout - Maximum time to wait in milliseconds (default: 5000)
 */
function waitForQRCodeLibrary(callback, timeout = 10000) {
  const startTime = Date.now();
  
  const checkQRCode = () => {
    if (typeof window.QRCode !== 'undefined' && window.QRCode.CorrectLevel) {
      console.log('QRCode library is now available');
      callback();
    } else if (Date.now() - startTime > timeout) {
      console.error('QRCode library failed to load within timeout period');
      const container = document.getElementById('barcode-container');
      if (container) {
        // Fallback: show the loyalty number as text
        const loyaltyNumber = container.getAttribute('data-loyalty-number');
        container.innerHTML = `
          <div style="text-align: center; padding: 20px; border: 2px dashed #ccc; background: #f9f9f9;">
            <p style="margin: 0; font-size: 14px; color: #666;">Loyalty Number:</p>
            <p style="margin: 10px 0 0 0; font-size: 18px; font-weight: bold; font-family: monospace;">${loyaltyNumber}</p>
            <p style="margin: 10px 0 0 0; font-size: 12px; color: #999;">QR Code unavailable</p>
          </div>
        `;
      }
    } else {
      // Check again after a short delay
      setTimeout(checkQRCode, 200);
    }
  };
  
  // Start checking
  checkQRCode();
}

/**
 * Generate a QR code from wallet number
 * @param {string} walletNumber - The wallet number (e.g., "247142596")
 * @param {string} containerId - The ID of the container element to render the QR code
 * @param {Object} options - Optional configuration for the QR code
 */
function generateWalletBarcode(walletNumber, containerId, options = {}) {
  // Default options for QR code
  const defaultOptions = {
    width: 200,
    height: 200,
    colorDark: "#000000",
    colorLight: "#ffffff",
    correctLevel: window.QRCode ? window.QRCode.CorrectLevel.M : 1,
    margin: 10
  };

  // Merge with provided options
  const config = { ...defaultOptions, ...options };

  // Get the container element
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Container with ID "${containerId}" not found`);
    return;
  }

  // Clear previous QR code if exists
  container.innerHTML = '';

  try {
    // Check if QRCode library is available
    if (typeof window.QRCode === 'undefined') {
      console.error('QRCode library is not loaded. Please ensure qrcode.js is loaded before calling this function.');
      container.innerHTML = `<p style="color: red;">QRCode library not available. Please refresh the page.</p>`;
      return;
    }

    // Generate QR code using QRCode library
    const qrCode = new window.QRCode(container, {
      text: walletNumber,
      width: config.width,
      height: config.height,
      colorDark: config.colorDark,
      colorLight: config.colorLight,
      correctLevel: window.QRCode.CorrectLevel.M
    });
    
    console.log(`QR code generated for wallet number: ${walletNumber}`);
    return qrCode;
  } catch (error) {
    console.error('Error generating QR code:', error);
    container.innerHTML = `<p style="color: red;">Error generating QR code: ${error.message}</p>`;
  }
}

/**
 * Generate QR codes for all voucher code elements
 * Finds all elements with class 'voucher-code-qr-img' and generates QR codes
 * using the value from their 'data-code' attribute
 */
function generateVoucherQRCodes() {
  const voucherQRContainers = document.querySelectorAll('.voucher-code-qr-img');
  
  if (voucherQRContainers.length === 0) {
    console.log('No voucher QR code containers found');
    return;
  }

  console.log(`Found ${voucherQRContainers.length} voucher QR code container(s)`);

  voucherQRContainers.forEach(function(container) {
    const voucherCode = container.getAttribute('data-code');
    
    if (!voucherCode) {
      console.warn('No data-code attribute found on voucher QR container');
      return;
    }

    // Skip if QR code already generated (has children)
    if (container.children.length > 0) {
      console.log(`QR code already exists for voucher code: ${voucherCode}`);
      return;
    }

    try {
      // Check if QRCode library is available
      if (typeof window.QRCode === 'undefined') {
        console.error('QRCode library is not loaded.');
        container.innerHTML = `<p style="color: red; font-size: 12px;">QR Code unavailable</p>`;
        return;
      }

      // Generate QR code using QRCode library
      const qrCode = new window.QRCode(container, {
        text: voucherCode,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: window.QRCode.CorrectLevel.M
      });
      
      console.log(`QR code generated for voucher code: ${voucherCode}`);
    } catch (error) {
      console.error('Error generating QR code for voucher:', error);
      container.innerHTML = `<p style="color: red; font-size: 12px;">Error generating QR code</p>`;
    }
  });
}
// End: Account bar

// Copy discount code functionality
function initCopyDiscountCode() {
  const copyElements = document.querySelectorAll('.copy-discount-code');
  
  copyElements.forEach(function(element) {
    element.addEventListener('click', function() {
      const discountCode = this.getAttribute('data-code');
      
      // Try to use the modern clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(discountCode).catch(function(err) {
          fallbackCopyTextToClipboard(discountCode);
        });
      } else {
        // Fallback for older browsers
        fallbackCopyTextToClipboard(discountCode);
      }
    });
  });
  
  function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
    } catch (err) {
      // Silent fail - no feedback needed
    }
    
    document.body.removeChild(textArea);
  }
}

// Initialize copy discount code functionality when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initCopyDiscountCode();
  initCopyVoucherCode();
});

// Copy voucher code functionality
function initCopyVoucherCode() {
  const copyElements = document.querySelectorAll('.voucher-code-qr-code');
  
  copyElements.forEach(function(element) {
    element.addEventListener('click', function() {
      const voucherCode = this.getAttribute('data-code');
      
      if (!voucherCode) {
        console.warn('No data-code attribute found on voucher QR code element');
        return;
      }
      
      // Try to use the modern clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(voucherCode).catch(function(err) {
          fallbackCopyTextToClipboard(voucherCode);
        });
      } else {
        // Fallback for older browsers
        fallbackCopyTextToClipboard(voucherCode);
      }
    });
  });
  
  function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
    } catch (err) {
      // Silent fail - no feedback needed
    }
    
    document.body.removeChild(textArea);
  }
}

// Start: Login Time Storage
// Flag to prevent multiple executions of storeLoginTime
let storeLoginTimeExecuted = false;

/**
 * Store login time to localStorage if customer data is valid
 * Checks if customer.email and customer.metafields.custom.wallet_metaobject.value.wallet_id.value are not blank
 */
function storeLoginTime() {
  // Check if hidden input with class "logincustomer" exists
  const loginCustomerInput = document.querySelector('input.logincustomer');
  if (!loginCustomerInput) {
    console.log('logincustomer input not found, skipping storeLoginTime...');
    return;
  }
  
  // Prevent multiple executions
  if (storeLoginTimeExecuted) {
    console.log('storeLoginTime already executed, skipping...');
    return;
  }
  storeLoginTimeExecuted = true;
  let email, walletId, useLocalStorageData = false;
  
  // First priority: Check if customer data is available from Liquid templating
  if (window.customerData && window.customerData.hasValidData && 
      window.customerData.email && window.customerData.walletId) {
    email = window.customerData.email;
    walletId = window.customerData.walletId;
    console.log('Using Liquid customer data');
  } else {
    // Fallback: Check localStorage for valid data
    const existingData = localStorage.getItem('customerLoginTime');
    if (existingData) {
      try {
        const parsedData = JSON.parse(existingData);
        if (parsedData.email && parsedData.walletId) {
          email = parsedData.email;
          walletId = parsedData.walletId;
          useLocalStorageData = true;
          console.log('Using localStorage customer data');
        }
      } catch (parseError) {
        console.log('Could not parse existing login data');
      }
    }
  }
  
  // Run if we have valid data from either source
  if (email && walletId) {
    try {
      console.log('Starting login time storage process...');
      
      // Get current timestamp
      const loginTime = new Date().toISOString();
      const currentTimestamp = Date.now();
      console.log('Timestamps generated:', { loginTime, currentTimestamp });
      
      // Get existing data from localStorage
      const existingData = localStorage.getItem('customerLoginTime');
      
      // Check if we should update the significant login timestamp (1+ day)
      let significantLoginTime = loginTime;
      let significantTimestamp = currentTimestamp;
      
      if (existingData && !useLocalStorageData) {
        try {
          console.log('Parsing existing data...');
          const parsedData = JSON.parse(existingData);
          const timeDifference = currentTimestamp - parsedData.timestamp;
          const oneDay = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
          
          // Run triggerWalletUpdateWebhook if current page is "/account"
          // if (window.location.pathname === '/account') {
          //   triggerWalletUpdateWebhook(email, walletId, significantLoginTime, significantTimestamp);
          // }
          
          if (timeDifference <= oneDay) {
            // Less than 1 day, keep the previous significant login time
            significantLoginTime = parsedData.significantLoginTime || loginTime;
            significantTimestamp = parsedData.significantTimestamp || currentTimestamp;
            console.log('Less than 1 day since last login - keeping previous significant login time');
          } else {
            console.log('More than 1 day since last login - updating significant login time');
            // Trigger webhooks when significant login time is updated (after 1 day)
            triggerWalletUpdateWebhook(email, walletId, significantLoginTime, significantTimestamp);
          }
        } catch (parseError) {
          console.log('Could not parse existing data for significant login time, using current time:', parseError);
        }
      }
      
      // Create login data object
      console.log('Creating login data object...');
      const loginData = {
        email: email,
        walletId: walletId,
        loginTime: loginTime,
        timestamp: currentTimestamp,
        significantLoginTime: significantLoginTime,
        significantTimestamp: significantTimestamp
      };
      
      console.log('Login data object created:', loginData);
      
      // Store in localStorage
      console.log('Storing in localStorage...');
      localStorage.setItem('customerLoginTime', JSON.stringify(loginData));
      
      console.log('Login time stored successfully:', loginData);
    } catch (error) {
      console.error('Error storing login time:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        email: email,
        walletId: walletId
      });
    }
  } else {
    // Check if URL is /account?firstlogin=true - if so, don't run
    const isAccountPage = window.location.pathname.includes('/account');
    const urlParams = new URLSearchParams(window.location.search);
    const firstLogin = urlParams.get('firstlogin');
    const isFirstLoginPage = isAccountPage && firstLogin === 'true';
    
    if (window.customerDataMinRegister && window.customerDataMinRegister.hasValidDataMinRegister && !isFirstLoginPage) {
      const webhookUrl = 'https://jumpstartcommerce.retool.com/url/metafields-fill';
      console.log('Triggering webhook to update wallet data');
      
      const payload = {
        email: window.customerDataMinRegister.email,
        phone: window.customerDataMinRegister.phone,
        first_name: window.customerDataMinRegister.first_name,
        last_name: window.customerDataMinRegister.last_name
      };
      
      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      })
      .then(response => {
        if (response.ok) {
          console.log('Webhook triggered successfully:', payload);
          return response.json();
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      })
      .then(data => {
        console.log('Webhook response:', data);
        location.reload();
      })
      .catch(error => {
        console.error('Webhook error:', error);
      });
    }
    console.log('No valid customer data available from Liquid or localStorage - skipping login time storage');
  }
}

// Call the function when the page loads - use a single initialization pattern
function initStoreLoginTime() {
  if (document.readyState === 'loading') {
    // DOM is still loading, wait for DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function() {
      storeLoginTime();
      // Check if points balance page is loaded and trigger webhook
      checkAndTriggerPointsBalanceWebhook();
      // Check if vouchers page is loaded and trigger webhook
      checkAndTriggerVoucherListAccountWebhook();
    });
  } else {
    // DOM is already loaded (interactive or complete)
    // DOMContentLoaded has already fired, so call immediately
    storeLoginTime();
    checkAndTriggerPointsBalanceWebhook();
    checkAndTriggerVoucherListAccountWebhook();
  }
}

// Initialize
initStoreLoginTime();

/**
 * Check if points balance element exists and trigger webhook if customer data is available
 */
function checkAndTriggerPointsBalanceWebhook() {
  // Check if points balance element exists on the page
  if (document.getElementById('points_balance') && !pointsBalanceWebhookTriggered) {
    console.log('Points balance element found on page');
    
    // Get customer data from Liquid templating or localStorage
    let email = null;
    
    // First priority: Check if customer data is available from Liquid templating
    if (window.customerData && window.customerData.hasValidData && window.customerData.email) {
      email = window.customerData.email;
      console.log('Using Liquid customer data for points balance webhook');
    } else {
      // Fallback: Check localStorage for valid data
      const existingData = localStorage.getItem('customerLoginTime');
      if (existingData) {
        try {
          const parsedData = JSON.parse(existingData);
          if (parsedData.email) {
            email = parsedData.email;
            console.log('Using localStorage customer data for points balance webhook');
          }
        } catch (parseError) {
          console.log('Could not parse existing data for points balance webhook');
        }
      }
    }
    
    // Trigger webhook if we have email data
    if (email) {
      pointsBalanceWebhookTriggered = true;
      triggerPointsBalanceWebhook(email);
    } else {
      console.log('No valid customer email available for points balance webhook');
    }
  }
}


/**
 * Trigger webhook to update wallet data
 * @param {string} email - Customer email
 * @param {string} walletId - Customer wallet ID
 * @param {string} significantLoginTime - Significant login time
 * @param {number} significantTimestamp - Significant timestamp
 */
function triggerWalletUpdateWebhook(email, walletId, significantLoginTime, significantTimestamp) {
  const webhookUrl = 'https://metrosg.retool.com/url/update-wallet';
  console.log('Triggering webhook to update wallet data');
  
  const payload = {
    customer_email: email
  };
  
  fetch(webhookUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (response.ok) {
      console.log('Webhook triggered successfully:', payload);
      return response.json();
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  })
  .then(data => {
    console.log('Webhook response:', data);
  })
  .catch(error => {
    console.error('Webhook error:', error);
  });
}

/**
 * Trigger webhook to update points balance
 * @param {string} email - Customer email
 */
function triggerPointsBalanceWebhook(email) {
  const webhookUrl = 'https://metrosg.retool.com/url/points-balance';
  console.log('Triggering webhook to update points balance');
  
  const payload = {
    customer_email: email
  };
  
  // Show loading overlay
  showPointsBalanceLoading();
  
  fetch(webhookUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (response.ok) {
      console.log('Points balance webhook triggered successfully:', payload);
      return response.json();
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  })
  .then(data => {
    console.log('Points balance webhook response:', data);
    // Hide loading overlay and populate table
    hidePointsBalanceLoading();
    populatePointsBalanceTable(data);
    // Also populate offline orders if data is available
    if (data.order_offline_date) {
      populateOfflineOrdersTable(data);
    }
  })
  .catch(error => {
    console.error('Points balance webhook error:', error);
    // Hide loading overlay on error
    hidePointsBalanceLoading();
  });
}

/**
 * Trigger webhook to update voucher list account
 * @param {string} email - Customer email
 */
function triggerVoucherListAccountWebhook(email) {
  const webhookUrl = 'https://metrosg.retool.com/url/voucher-list-account';
  console.log('Triggering webhook to update voucher list account');
  
  const payload = {
    customer_email: email
  };
  
  // Return a promise so we can chain it
  return fetch(webhookUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (response.ok) {
      console.log('Voucher list account webhook triggered successfully:', payload);
      return response.json();
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  })
  .then(data => {
    console.log('Voucher list account webhook response:', data);
    // Filter the response data based on existing account_campaign_ids on the page
    
    // Process active vouchers (voucher_list)
    if (data && data.voucher_list && Array.isArray(data.voucher_list)) {
      const filteredVoucherList = filterVoucherListByAccountIds(data.voucher_list);
      console.log('Filtered voucher list (removed matching account_ids):', filteredVoucherList);
      // Create and store voucher rows from filtered list
      if (filteredVoucherList.length > 0) {
        createVoucherRowsFromFilteredList(filteredVoucherList, 'active');
      }
    }
    
    // Process redeemed vouchers (voucher_list_redeem)
    if (data && data.voucher_list_redeem && Array.isArray(data.voucher_list_redeem)) {
      const filteredRedeemedList = filterVoucherListByAccountIds(data.voucher_list_redeem);
      console.log('Filtered redeemed voucher list (removed matching account_ids):', filteredRedeemedList);
      if (filteredRedeemedList.length > 0) {
        createVoucherRowsFromFilteredList(filteredRedeemedList, 'redeemed');
      }
    }
    
    // Process expired vouchers (voucher_list_expired)
    if (data && data.voucher_list_expired && Array.isArray(data.voucher_list_expired)) {
      const filteredExpiredList = filterVoucherListByAccountIds(data.voucher_list_expired);
      console.log('Filtered expired voucher list (removed matching account_ids):', filteredExpiredList);
      if (filteredExpiredList.length > 0) {
        createVoucherRowsFromFilteredList(filteredExpiredList, 'expired');
      }
    }
    
    return data; // Return data for chaining
  })
  .catch(error => {
    console.error('Voucher list account webhook error:', error);
    throw error; // Re-throw for error handling in chain
  });
}

/**
 * Filter voucher list from webhook response by removing vouchers that match account_campaign_ids on the page
 * @param {Array} voucherList - Array of voucher objects with account_id from webhook response
 * @returns {Array} Filtered array with matching vouchers removed
 */
function filterVoucherListByAccountIds(voucherList) {
  if (!voucherList || !Array.isArray(voucherList) || voucherList.length === 0) {
    console.log('No vouchers to process or invalid voucher list');
    return [];
  }

  // Get all data-account-campaign-id values from existing voucher rows on the page
  const voucherRows = document.querySelectorAll('#vouchers .voucher-row[data-account-campaign-id]');
  const existingAccountCampaignIds = new Set();
  
  voucherRows.forEach(row => {
    const accountCampaignId = row.getAttribute('data-account-campaign-id');
    if (accountCampaignId) {
      existingAccountCampaignIds.add(String(accountCampaignId));
    }
  });

  console.log('Existing account_campaign_ids on page:', Array.from(existingAccountCampaignIds));
  console.log('Original voucher list count:', voucherList.length);

  // Filter out vouchers where account_id matches any existing account_campaign_id
  const filteredList = voucherList.filter(voucher => {
    const accountId = String(voucher.account_id);
    const shouldRemove = existingAccountCampaignIds.has(accountId);
    
    if (shouldRemove) {
      console.log(`Filtering out voucher with account_id: ${accountId} (matches existing account_campaign_id)`);
    }
    
    return !shouldRemove;
  });

  console.log(`Filtered voucher list count: ${filteredList.length} (removed ${voucherList.length - filteredList.length} matching vouchers)`);

  return filteredList;
}

/**
 * Create and add voucher rows from filtered voucher list
 * @param {Array} filteredVoucherList - Filtered array of voucher objects
 * @param {string} containerType - Type of container: 'active', 'redeemed', or 'expired'
 */
function createVoucherRowsFromFilteredList(filteredVoucherList, containerType = 'active') {
  if (!filteredVoucherList || filteredVoucherList.length === 0) {
    console.log('No vouchers to create');
    return;
  }

  console.log(`Creating ${filteredVoucherList.length} voucher row(s) from filtered list for ${containerType} vouchers`);

  filteredVoucherList.forEach(voucher => {
    const voucherRow = createVoucherRowElement(voucher, containerType);
    if (voucherRow) {
      const container = getVoucherContainerByType(containerType);
      if (container) {
        // Remove empty message if it exists
        const emptyMessage = container.querySelector('.voucher-row-empty');
        if (emptyMessage) {
          emptyMessage.remove();
        }
        
        container.appendChild(voucherRow);
        
        // Add copy functionality to the new voucher
        const copyElement = voucherRow.querySelector('.voucher-code-qr-code');
        if (copyElement) {
          copyElement.addEventListener('click', function() {
            const voucherCode = this.getAttribute('data-code');
            if (voucherCode) {
              if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(voucherCode).catch(function(err) {
                  fallbackCopyTextToClipboard(voucherCode);
                });
              } else {
                fallbackCopyTextToClipboard(voucherCode);
              }
            }
          });
        }
        
        // Generate QR code for the new voucher
        waitForQRCodeLibrary(() => {
          const qrContainer = voucherRow.querySelector('.voucher-code-qr-img');
          if (qrContainer && qrContainer.getAttribute('data-code')) {
            generateQRCodeForContainer(qrContainer);
          }
        });
      }
    }
  });

  console.log('Voucher rows created and added to containers');
}

/**
 * Create a voucher row element from voucher data
 * @param {Object} voucher - Voucher object from webhook response
 * @param {string} containerType - Type of container: 'active', 'redeemed', or 'expired'
 * @returns {HTMLElement|null} Created voucher row element or null
 */
function createVoucherRowElement(voucher, containerType = 'active') {
  if (!voucher || !voucher.account_id) {
    console.warn('Invalid voucher data:', voucher);
    return null;
  }

  // For active vouchers, coupon_code is required
  if (containerType === 'active' && !voucher.coupon_code) {
    console.warn('Active voucher missing coupon_code:', voucher);
    return null;
  }

  // Format dates from ISO format to DD/MM/YYYY
  const startDate = formatDateForVoucher(voucher.start_date);
  const endDate = formatDateForVoucher(voucher.end_date);
  const status = voucher.status || 'ACTIVE';
  const name = voucher.name || 'Voucher';

  // Hide birthday vouchers from the account dashboard (case-insensitive).
  // Mirrors the Liquid filter in sections/jsc-sections-account-voucher.liquid.
  if (name.toLowerCase().includes('birthday')) {
    return null;
  }

  const accountId = String(voucher.account_id);
  const couponCode = voucher.coupon_code || '';

  // Create the voucher row element
  const voucherRow = document.createElement('div');
  voucherRow.setAttribute('data-account-campaign-id', accountId);

  // Different HTML structure based on container type
  if (containerType === 'active') {
    // Check if voucher has "offline" tag (case-insensitive)
    const hasOfflineTag = Array.isArray(voucher.tags) && 
      voucher.tags.some(tag => typeof tag === 'string' && tag.toLowerCase().includes('offline'));
    
    // Determine button class - no "ee-voucher-not-create-yet" if offline tag exists
    const buttonClass = hasOfflineTag ? 'voucher-row-use-button' : 'voucher-row-use-button ee-voucher-not-create-yet';

    voucherRow.className = 'voucher-row active-ee-voucher';
    voucherRow.innerHTML = `
      <div class="voucher-row-left">
        <div class="voucher-row-status">${status}</div>
        <div>${escapeHtml(name)}</div>
      </div>
      <div class="voucher-row-date">
        [${startDate} - ${endDate}]
      </div>
      <div class="voucher-row-use">
        <div class="${buttonClass}">
          Use
        </div>
        <div class="voucher-code-qr-popup">
          <div class="voucher-code-qr-img" data-code="${escapeHtml(couponCode)}"></div>
          <div class="voucher-code-qr-code" data-code="${escapeHtml(couponCode)}" style="cursor: pointer;">
            ${escapeHtml(couponCode)} 
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"></path></svg>
          </div>
          <div class="voucher-code-qr-cancel">
            cancel
          </div>
        </div>
      </div>
    `;
  } else if (containerType === 'redeemed') {
    // Redeemed vouchers - simpler structure without "Use" button
    const displayStatus = status !== 'ACTIVE' ? status : 'REDEEMED';
    voucherRow.className = 'voucher-row';
    voucherRow.innerHTML = `
      <div class="voucher-row-left">
        <div class="voucher-row-status">${displayStatus}</div>
        <div>${escapeHtml(name)}</div>
      </div>
      <div class="voucher-row-date">
        [${startDate} - ${endDate}]
      </div>
    `;
  } else if (containerType === 'expired') {
    // Expired vouchers - simpler structure without "Use" button
    voucherRow.className = 'voucher-row';
    voucherRow.innerHTML = `
      <div class="voucher-row-left">
        <div class="voucher-row-status">EXPIRED</div>
        <div>${escapeHtml(name)}</div>
      </div>
      <div class="voucher-row-date">
        [${startDate} - ${endDate}]
      </div>
    `;
  }

  return voucherRow;
}

/**
 * Format ISO date string to DD/MM/YYYY format
 * @param {string} isoDateString - ISO date string (e.g., "2025-11-28T06:33:07Z")
 * @returns {string} Formatted date string (e.g., "28/11/2025")
 */
function formatDateForVoucher(isoDateString) {
  if (!isoDateString) return '';
  
  try {
    const date = new Date(isoDateString);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string:', isoDateString);
      return '';
    }
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

/**
 * Get the appropriate voucher container based on voucher status and dates
 * @param {Object} voucher - Voucher object
 * @returns {HTMLElement|null} Container element or null
 */
function getVoucherContainer(voucher) {
  const vouchersSection = document.getElementById('vouchers');
  if (!vouchersSection) {
    console.warn('Vouchers section not found');
    return null;
  }

  const status = (voucher.status || '').toUpperCase();
  const now = new Date();
  const endDate = voucher.end_date ? new Date(voucher.end_date) : null;

  // Determine which container to use
  let container;
  if (status === 'ACTIVE' && endDate && endDate > now) {
    container = vouchersSection.querySelector('.vouchers-content-container.active-vouchers');
  } else if (status !== 'ACTIVE' && endDate && endDate > now) {
    container = vouchersSection.querySelector('.vouchers-content-container.redeemed-vouchers');
  } else if (endDate && endDate < now) {
    container = vouchersSection.querySelector('.vouchers-content-container.expired-vouchers');
  } else {
    // Default to active vouchers
    container = vouchersSection.querySelector('.vouchers-content-container.active-vouchers');
  }

  return container;
}

/**
 * Get voucher container by type
 * @param {string} type - Container type: 'active', 'redeemed', or 'expired'
 * @returns {HTMLElement|null} Container element or null
 */
function getVoucherContainerByType(type) {
  const vouchersSection = document.getElementById('vouchers');
  if (!vouchersSection) {
    console.warn('Vouchers section not found');
    return null;
  }

  let container;
  switch (type) {
    case 'redeemed':
      container = vouchersSection.querySelector('.vouchers-content-container.redeemed-vouchers');
      break;
    case 'expired':
      container = vouchersSection.querySelector('.vouchers-content-container.expired-vouchers');
      break;
    case 'active':
    default:
      container = vouchersSection.querySelector('.vouchers-content-container.active-vouchers');
      break;
  }

  return container;
}

/**
 * Escape HTML to prevent XSS
 * @param {string} text - Text to escape
 * @returns {string} Escaped text
 */
function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Generate QR code for a specific container
 * @param {HTMLElement} container - Container element with data-code attribute
 */
function generateQRCodeForContainer(container) {
  const voucherCode = container.getAttribute('data-code');
  
  if (!voucherCode) {
    console.warn('No data-code attribute found on QR container');
    return;
  }

  // Skip if QR code already generated
  if (container.children.length > 0) {
    console.log(`QR code already exists for voucher code: ${voucherCode}`);
    return;
  }

  try {
    // Check if QRCode library is available
    if (typeof window.QRCode === 'undefined') {
      console.error('QRCode library is not loaded.');
      container.innerHTML = `<p style="color: red; font-size: 12px;">QR Code unavailable</p>`;
      return;
    }

    // Generate QR code using QRCode library
    const qrCode = new window.QRCode(container, {
      text: voucherCode,
      width: 200,
      height: 200,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: window.QRCode.CorrectLevel.M
    });
    
    console.log(`QR code generated for voucher code: ${voucherCode}`);
  } catch (error) {
    console.error('Error generating QR code for voucher:', error);
  }
}

/**
 * Check if vouchers element exists and trigger webhook if customer data is available
 */
function checkAndTriggerVoucherListAccountWebhook() {
  // Check if vouchers element exists on the page
  console.log('checkAndTriggerVoucherListAccountWebhook');
  
  if (document.getElementById('vouchers') && !voucherListAccountWebhookTriggered) {
    console.log('Vouchers element found on page');
    
    // Get customer data from Liquid templating or localStorage
    let email = null;
    
    // First priority: Check if customer data is available from Liquid templating
    if (window.customerData && window.customerData.hasValidData && window.customerData.email) {
      email = window.customerData.email;
      console.log('Using Liquid customer data for voucher list account webhook');
    } else {
      // Fallback: Check localStorage for valid data
      const existingData = localStorage.getItem('customerLoginTime');
      if (existingData) {
        try {
          const parsedData = JSON.parse(existingData);
          if (parsedData.email) {
            email = parsedData.email;
            console.log('Using localStorage customer data for voucher list account webhook');
          }
        } catch (parseError) {
          console.log('Could not parse existing data for voucher list account webhook');
        }
      }
    }
    
    // Trigger webhook if we have email data
    if (email) {
      voucherListAccountWebhookTriggered = true;
      triggerVoucherListAccountWebhook(email);
    } else {
      console.log('No valid customer email available for voucher list account webhook');
    }
  }
}


/**
 * Show loading overlay on points balance and vouchers sections only
 */
function showPointsBalanceLoading() {
  // Add spinner animation if not already added
  if (!document.getElementById('points-spinner-styles')) {
    const style = document.createElement('style');
    style.id = 'points-spinner-styles';
    style.textContent = `
      @keyframes points-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Show overlay on points_balance element
  const pointsBalanceElement = document.getElementById('points_balance');
  if (pointsBalanceElement) {
    // Ensure parent has position relative for absolute positioning
    const computedStyle = window.getComputedStyle(pointsBalanceElement);
    if (computedStyle.position === 'static') {
      pointsBalanceElement.style.position = 'relative';
    }
    
    let loadingOverlay = pointsBalanceElement.querySelector('#points-loading-overlay');
    if (!loadingOverlay) {
      loadingOverlay = document.createElement('div');
      loadingOverlay.id = 'points-loading-overlay';
      loadingOverlay.className = 'points-loading-overlay';
      loadingOverlay.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        pointer-events: auto;
      `;
      loadingOverlay.innerHTML = `
        <div class="points-loading-spinner" style="
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top-color: #fff;
          border-radius: 50%;
          animation: points-spin 0.8s linear infinite;
        "></div>
      `;
      pointsBalanceElement.appendChild(loadingOverlay);
    }
    
    // Ensure overlay is visible
    loadingOverlay.style.display = 'flex';
    loadingOverlay.style.visibility = 'visible';
    loadingOverlay.style.opacity = '1';
  }
  
  // Show overlay on vouchers element
  const vouchersElement = document.getElementById('vouchers');
  if (vouchersElement) {
    // Ensure parent has position relative for absolute positioning
    const computedStyle = window.getComputedStyle(vouchersElement);
    if (computedStyle.position === 'static') {
      vouchersElement.style.position = 'relative';
    }
    
    let loadingOverlay = vouchersElement.querySelector('#vouchers-loading-overlay');
    if (!loadingOverlay) {
      loadingOverlay = document.createElement('div');
      loadingOverlay.id = 'vouchers-loading-overlay';
      loadingOverlay.className = 'vouchers-loading-overlay';
      loadingOverlay.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        pointer-events: auto;
      `;
      loadingOverlay.innerHTML = `
        <div class="points-loading-spinner" style="
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top-color: #fff;
          border-radius: 50%;
          animation: points-spin 0.8s linear infinite;
        "></div>
      `;
      vouchersElement.appendChild(loadingOverlay);
    }
    
    // Ensure overlay is visible
    loadingOverlay.style.display = 'flex';
    loadingOverlay.style.visibility = 'visible';
    loadingOverlay.style.opacity = '1';
  }
}

/**
 * Hide loading overlay on points balance and vouchers sections
 */
function hidePointsBalanceLoading() {
  // Hide overlay on points_balance element
  const pointsBalanceElement = document.getElementById('points_balance');
  if (pointsBalanceElement) {
    const loadingOverlay = pointsBalanceElement.querySelector('#points-loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'none';
    }
  }
  
  // Hide overlay on vouchers element
  const vouchersElement = document.getElementById('vouchers');
  if (vouchersElement) {
    const loadingOverlay = vouchersElement.querySelector('#vouchers-loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'none';
    }
  }
}

/**
 * Populate points balance table with response data
 * @param {Object} data - Response data containing points_data array
 */
function populatePointsBalanceTable(data) {
  const pointsBalanceElement = document.getElementById('points_balance');
  if (!pointsBalanceElement || !data.points_data) {
    console.log('No points balance element or points data available');
    return;
  }
  
  const container = pointsBalanceElement.querySelector('.points-transactions-container');
  if (!container) {
    console.log('No points transactions container found');
    return;
  }
  
  // Store all points data for pagination
  window.pointsData = data.points_data;
  window.currentPage = 1;
  window.itemsPerPage = 10;
  
  // Show initial rows (first 10)
  showPointsPage(1);
  
  console.log('Points balance table populated with', data.points_data.length, 'entries');
}

/**
 * Show a specific page of points data
 * @param {number} page - Page number to display
 */
function showPointsPage(page) {
  const pointsBalanceElement = document.getElementById('points_balance');
  const container = pointsBalanceElement.querySelector('.points-transactions-container');
  
  if (!window.pointsData || !container) return;
  
  const startIndex = (page - 1) * window.itemsPerPage;
  const endIndex = startIndex + window.itemsPerPage;
  const pageData = window.pointsData.slice(startIndex, endIndex);
  
  // Clear existing rows only on first page (keep the static header)
  if (page === 1) {
    // Preserve the first child (static header) and remove all dynamically added entries
    const firstChild = container.firstElementChild;
    container.innerHTML = '';
    if (firstChild) {
      container.appendChild(firstChild);
    }
  }

  const availablePointsElements = document.querySelectorAll('.available-points');
  availablePointsElements.forEach(element => {
    element.textContent = '0';
  });
  $('.points-redeem-button').addClass('disabled');
  
  // If points data is empty, show empty state message
  if (window.pointsData.length === 0) {
    const emptyRow = document.createElement('div');
    emptyRow.className = 'voucher-row-empty';
    emptyRow.innerHTML = 'No transactions data';
    container.appendChild(emptyRow);
    return;
  }
  
  // Add rows for current page
  pageData.forEach(pointEntry => {
    const row = document.createElement('div');
    row.className = 'transactions-container-header';
    
    row.innerHTML = `
      <div class="transactions-container">${pointEntry.date}</div>
      <div class="transactions-type-container">
        <div class="transaction-type">${pointEntry.event}</div>
        <div class="transaction-points">${pointEntry.points}</div>
      </div>
    `;
    
    container.appendChild(row);
  });
  
  // Update .available-points with currentUsablePoints from the first entry
  if (pageData.length > 0 && pageData[0].currentUsablePoints !== undefined) {
    const availablePointsElements = document.querySelectorAll('.available-points');
    availablePointsElements.forEach(element => {
      element.textContent = pageData[0].currentUsablePoints;
    });
    $('.points-redeem-button').removeClass('disabled');
  }
  
  // Add or update load more button
  updateLoadMoreButton();
}

/**
 * Update the load more button based on current page and total items
 */
function updateLoadMoreButton() {
  const pointsBalanceElement = document.getElementById('points_balance');
  const pointsTransactionsContainer = pointsBalanceElement.querySelector('.points-transactions-container');
  
  if (!window.pointsData || !pointsTransactionsContainer) return;
  
  const totalItems = window.pointsData.length;
  const totalPages = Math.ceil(totalItems / window.itemsPerPage);
  const currentPage = window.currentPage;
  
  // Remove existing load more button - search within the entire points_balance element
  const existingButton = pointsBalanceElement.querySelector('.points-load-more-btn');
  if (existingButton) {
    existingButton.remove();
  }
  
  // Add load more button if there are more pages
  if (currentPage < totalPages) {
    const loadMoreButton = document.createElement('div');
    loadMoreButton.className = 'points-load-more-btn';
    loadMoreButton.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding: 15px 0;
    `;
    
    const button = document.createElement('button');
    button.className = 'button button--primary load-more-points-btn';
    button.style.cssText = `
      background: black;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 0px;
      cursor: pointer;
      font-size: 14px;
    `;
    button.textContent = `Load More`;
    
    button.addEventListener('click', function() {
      window.currentPage++;
      showPointsPage(window.currentPage);
    });
    
    loadMoreButton.appendChild(button);
    
    // Insert the button right after the points-transactions-container
    pointsTransactionsContainer.insertAdjacentElement('afterend', loadMoreButton);
  }
}
// End: Login Time Storage

// Start: Offline Orders Management
/**
 * Populate offline orders table with data from order_offline_date
 * @param {Object} data - Response data containing order_offline_date array with offline orders
 */
function populateOfflineOrdersTable(data) {
  console.log('populateOfflineOrdersTable called with data:', data);
  
  const offlineOrdersElement = document.querySelector('.account-orders-offline-container');
  console.log('offlineOrdersElement found:', offlineOrdersElement);
  
  if (!offlineOrdersElement) {
    console.log('No offline orders element found');
    return;
  }
  
  // Check if there's no data or empty array
  if (!data.order_offline_date || data.order_offline_date.length === 0) {
    console.log('No offline orders data available, showing empty state');
    
    // Remove the table and show empty state
    const table = offlineOrdersElement.querySelector('table');
    if (table) {
      table.remove();
    }
    
    // Remove any existing load more button
    const existingButton = offlineOrdersElement.querySelector('.offline-orders-load-more-btn');
    if (existingButton) {
      existingButton.remove();
    }
    
    // Add empty state message
    const emptyState = document.createElement('div');
    emptyState.className = 'account-orders-offline-empty prose prose-justify-center';
    emptyState.innerHTML = `
      <p class="subheading">No offline orders found</p>
    `;
    
    offlineOrdersElement.appendChild(emptyState);
    return;
  }
  
  const table = offlineOrdersElement.querySelector('table tbody');
  console.log('table tbody found:', table);
  
  if (!table) {
    console.log('No table body found for offline orders');
    return;
  }
  
  // Clear existing rows and load more button
  table.innerHTML = '';
  
  // Store all offline orders data for pagination
  window.offlineOrdersData = data.order_offline_date;
  window.currentOfflinePage = 1;
  window.offlineItemsPerPage = 5;
  
  console.log('Stored offline orders data:', window.offlineOrdersData);
  
  // Show initial rows (first 3)
  showOfflineOrdersPage(1);
  
  console.log('Offline orders table populated with', data.order_offline_date.length, 'entries');
}

/**
 * Show popup with basket items for an order
 * @param {Object} orderEntry - The order data object containing basketItems
 */
function showBasketItemsPopup(orderEntry) {
  console.log('showBasketItemsPopup called with orderEntry:', orderEntry);
  
  if (!orderEntry || !orderEntry.basketItems || orderEntry.basketItems.length === 0) {
    console.log('No basket items available for this order');
    alert('No items found for this order');
    return;
  }
  
  // Remove existing popup if any
  const existingPopup = document.querySelector('.basket-items-popup');
  if (existingPopup) {
    existingPopup.remove();
  }
  
  // Create popup overlay
  const popupOverlay = document.createElement('div');
  popupOverlay.className = 'basket-items-popup';
  popupOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 20px;
  `;
  
  // Create popup content
  const popupContent = document.createElement('div');
  popupContent.style.cssText = `
    background: white;
    max-width: 600px;
    width: 100%;
    max-height: 80vh;
    overflow-y: auto;
    border-radius: 4px;
    padding: 30px;
    position: relative;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  `;
  
  // Create header
  const header = document.createElement('div');
  header.style.cssText = `
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
  `;
  
  const orderNumber = document.createElement('h3');
  orderNumber.style.cssText = `
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: bold;
  `;
  orderNumber.textContent = `Order: ${orderEntry.orderNumber || 'N/A'}`;
  
  const orderDate = document.createElement('p');
  orderDate.style.cssText = `
    margin: 5px 0;
    color: #666;
    font-size: 14px;
  `;
  orderDate.textContent = `Date: ${orderEntry.date || 'N/A'}`;
  
  header.appendChild(orderNumber);
  header.appendChild(orderDate);
  
  // Create items list
  const itemsList = document.createElement('div');
  itemsList.style.cssText = `
    margin-bottom: 20px;
  `;
  
  const itemsTitle = document.createElement('h4');
  itemsTitle.style.cssText = `
    margin: 0 0 15px 0;
    font-size: 16px;
    font-weight: bold;
  `;
  itemsTitle.textContent = `Items (${orderEntry.basketItems.length})`;
  itemsList.appendChild(itemsTitle);
  
  // Create items table
  const itemsTable = document.createElement('table');
  itemsTable.style.cssText = `
    width: 100%;
    border-collapse: collapse;
  `;
  
  // Table header
  const tableHeader = document.createElement('thead');
  tableHeader.innerHTML = `
    <tr style="background: #f5f5f5; border-bottom: 2px solid #e0e0e0;">
      <th style="padding: 10px; text-align: left; font-weight: bold; font-size: 14px;">Item</th>
      <th style="padding: 10px; text-align: left; font-weight: bold; font-size: 14px;">SKU</th>
      <th style="padding: 10px; text-align: right; font-weight: bold; font-size: 14px;">Price</th>
      <th style="padding: 10px; text-align: center; font-weight: bold; font-size: 14px;">Qty</th>
      <th style="padding: 10px; text-align: right; font-weight: bold; font-size: 14px;">Total</th>
    </tr>
  `;
  
  // Table body
  const tableBody = document.createElement('tbody');
  
  orderEntry.basketItems.forEach((item, index) => {
    const row = document.createElement('tr');
    row.style.cssText = `
      border-bottom: 1px solid #e0e0e0;
      ${index % 2 === 0 ? 'background: #fafafa;' : 'background: white;'}
    `;
    
    row.innerHTML = `
      <td style="padding: 12px; font-size: 14px;">${item.lineItemName || 'N/A'}</td>
      <td style="padding: 12px; font-size: 14px; color: #666;">${item.lineItemSku || 'N/A'}</td>
      <td style="padding: 12px; text-align: right; font-size: 14px;">$${item.lineItemPrice || '0.00'}</td>
      <td style="padding: 12px; text-align: center; font-size: 14px;">${item.lineItemQty || '0'}</td>
      <td style="padding: 12px; text-align: right; font-size: 14px; font-weight: bold;">$${item.lineItemTotalPriceAfterDiscount || item.lineItemTotalPrice || '0.00'}</td>
    `;
    
    tableBody.appendChild(row);
  });
  
  itemsTable.appendChild(tableHeader);
  itemsTable.appendChild(tableBody);
  itemsList.appendChild(itemsTable);
  
  // Create close button
  const closeButton = document.createElement('button');
  closeButton.textContent = 'Close';
  closeButton.style.cssText = `
    width: 100%;
    padding: 12px;
    background: black;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    font-weight: bold;
    margin-top: 20px;
  `;
  closeButton.addEventListener('click', function() {
    popupOverlay.remove();
  });
  
  // Close on overlay click (outside popup)
  popupOverlay.addEventListener('click', function(e) {
    if (e.target === popupOverlay) {
      popupOverlay.remove();
    }
  });
  
  // Close on ESC key
  const handleEscKey = function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      popupOverlay.remove();
      document.removeEventListener('keydown', handleEscKey);
    }
  };
  document.addEventListener('keydown', handleEscKey);
  
  // Assemble popup
  popupContent.appendChild(header);
  popupContent.appendChild(itemsList);
  popupContent.appendChild(closeButton);
  popupOverlay.appendChild(popupContent);
  
  // Add to document
  document.body.appendChild(popupOverlay);
}

/**
 * Show a specific page of offline orders data
 * @param {number} page - Page number to display
 */
function showOfflineOrdersPage(page) {
  console.log('showOfflineOrdersPage called with page:', page);
  
  const offlineOrdersElement = document.querySelector('.account-orders-offline-container');
  const table = offlineOrdersElement.querySelector('table tbody');
  
  console.log('offlineOrdersElement:', offlineOrdersElement);
  console.log('table:', table);
  console.log('window.offlineOrdersData:', window.offlineOrdersData);
  
  if (!window.offlineOrdersData) {
    console.log('No offlineOrdersData available');
    return;
  }
  
  if (!table) {
    console.log('No table found');
    return;
  }
  
  const startIndex = (page - 1) * window.offlineItemsPerPage;
  const endIndex = startIndex + window.offlineItemsPerPage;
  const pageData = window.offlineOrdersData.slice(startIndex, endIndex);
  console.log('pageData:', pageData);
  console.log('startIndex:', startIndex, 'endIndex:', endIndex);
  
  // Clear existing rows only on first page
  if (page === 1) {
    table.innerHTML = '';
    console.log('Cleared table for first page');
  }
  
  // Add rows for current page
  console.log('About to process', pageData.length, 'orders');
  
  pageData.forEach((orderEntry, index) => {
    console.log('Processing order', index + 1, ':', orderEntry);
    
    const row = document.createElement('tr');
    row.style.cursor = 'pointer';
    
    // Format date if needed (assuming DD/MM/YYYY format)
    const orderDate = orderEntry.date || 'N/A';
    let formattedDate = orderDate;
    
    // Try to format the date if it's in DD/MM/YYYY format
    if (orderDate !== 'N/A' && orderDate.includes('/')) {
      const dateParts = orderDate.split('/');
      if (dateParts.length === 3) {
        // Convert DD/MM/YYYY to MM/DD/YYYY for proper Date parsing
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];
        const dateObj = new Date(`${month}/${day}/${year}`);
        if (!isNaN(dateObj.getTime())) {
          formattedDate = dateObj.toLocaleDateString();
        }
      }
    }
    
    const rowHTML = `
      <td class="subheading">${orderEntry.orderNumber || 'N/A'}</td>
      <td class="subheading text-subdued">${formattedDate}</td>
      <td class="subheading text-subdued">${orderEntry.paymentStatus || 'N/A'}</td>
      <td class="subheading text-subdued">${orderEntry.total || 'N/A'}</td>
    `;
    
    console.log('Row HTML:', rowHTML);
    row.innerHTML = rowHTML;
    
    // Store full order data with the row
    row.dataset.orderData = JSON.stringify(orderEntry);
    
    // Add click handler to show basket items popup
    row.addEventListener('click', function(e) {
      e.stopPropagation();
      showBasketItemsPopup(orderEntry);
    });
    
    console.log('Appending row to table');
    table.appendChild(row);
  });
  
  console.log('Finished processing orders. Table now has', table.children.length, 'rows');
  
  // Add or update load more button
  updateOfflineOrdersLoadMoreButton();
}

/**
 * Update the load more button for offline orders based on current page and total items
 */
function updateOfflineOrdersLoadMoreButton() {
  const offlineOrdersElement = document.querySelector('.account-orders-offline-container');
  const tableContainer = offlineOrdersElement.querySelector('.account-orders-offline');
  
  if (!window.offlineOrdersData || !tableContainer) return;
  
  const totalItems = window.offlineOrdersData.length;
  const totalPages = Math.ceil(totalItems / window.offlineItemsPerPage);
  const currentPage = window.currentOfflinePage;
  
  // Remove existing load more button
  const existingButton = tableContainer.querySelector('.offline-orders-load-more-btn');
  if (existingButton) {
    existingButton.remove();
  }
  
  // Add load more button if there are more pages
  if (currentPage < totalPages) {
    const loadMoreButton = document.createElement('div');
    loadMoreButton.className = 'offline-orders-load-more-btn';
    loadMoreButton.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding: 15px 0;
    `;
    
    const button = document.createElement('button');
    button.className = 'button button--primary load-more-offline-orders-btn';
    button.style.cssText = `
      background: black;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 0px;
      cursor: pointer;
      font-size: 14px;
    `;
    button.textContent = `Load More Offline Orders`;
    
    button.addEventListener('click', function() {
      window.currentOfflinePage++;
      showOfflineOrdersPage(window.currentOfflinePage);
    });
    
    loadMoreButton.appendChild(button);
    tableContainer.appendChild(loadMoreButton);
  }
}

/**
 * Show loading overlay on offline orders table
 */
function showOfflineOrdersLoading() {
  const offlineOrdersElement = document.querySelector('.account-orders-offline-container');
  if (offlineOrdersElement) {
    const table = offlineOrdersElement.querySelector('table');
    if (table) {
      // Make table container relative positioned (always ensure this)
      const tableContainer = table.parentElement;
      const computedStyle = window.getComputedStyle(tableContainer);
      if (computedStyle.position === 'static' || !computedStyle.position) {
        tableContainer.style.position = 'relative';
      }
      
      // Create loading overlay if it doesn't exist
      let loadingOverlay = offlineOrdersElement.querySelector('.offline-orders-loading-overlay');
      if (!loadingOverlay) {
        loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'offline-orders-loading-overlay';
        loadingOverlay.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          pointer-events: auto;
        `;
        loadingOverlay.innerHTML = '<div style="font-size: 16px; color: #666;">Loading offline orders...</div>';
        
        tableContainer.appendChild(loadingOverlay);
      }
      
      // Ensure overlay is visible
      loadingOverlay.style.display = 'flex';
      loadingOverlay.style.visibility = 'visible';
      loadingOverlay.style.opacity = '1';
    } else {
      console.warn('Offline orders table not found');
    }
  } else {
    console.warn('Offline orders element not found');
  }
}

/**
 * Hide loading overlay on offline orders table
 */
function hideOfflineOrdersLoading() {
  const offlineOrdersElement = document.querySelector('.account-orders-offline-container');
  if (offlineOrdersElement) {
    const loadingOverlay = offlineOrdersElement.querySelector('.offline-orders-loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'none';
    }
  }
}
// End: Offline Orders Management

// Voucher Redemption Function
window.redeemVoucher = async function(button) {
  // Check if button has disabled class
  // if (button.classList.contains('redeem-voucher-disabled')) {
  //   return;
  // }
  
  // Show full page loading overlay for voucher redemption
  let loadingOverlay = document.getElementById('voucher-loading-overlay');
  if (!loadingOverlay) {
    loadingOverlay = document.createElement('div');
    loadingOverlay.id = 'voucher-loading-overlay';
    loadingOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      pointer-events: auto;
    `;
    loadingOverlay.innerHTML = `
      <div class="voucher-loading-spinner" style="
        width: 40px;
        height: 40px;
        border: 4px solid rgba(255, 255, 255, 0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: voucher-spin 0.8s linear infinite;
      "></div>
    `;
    
    // Add spinner animation if not already added
    if (!document.getElementById('voucher-spinner-styles')) {
      const style = document.createElement('style');
      style.id = 'voucher-spinner-styles';
      style.textContent = `
        @keyframes voucher-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(loadingOverlay);
  }
  // Ensure overlay is visible
  loadingOverlay.style.display = 'flex';
  loadingOverlay.style.visibility = 'visible';
  loadingOverlay.style.opacity = '1';
  
  try {
    // Get required data from hidden inputs and button attributes
    const email = document.querySelector('.customer-email')?.value || '';
    const walletId = document.querySelector('.customer-wallet-id')?.value || '';
    const accountId = document.querySelector('.customer-account-id')?.value || '';
    const pointsRequired = button.getAttribute('data-points-required') || '';
    const campaignId = button.getAttribute('data-redeem-voucher-id') || '';
    
    // Prepare request body
    const requestBody = {
      email: email,
      walletId: walletId,
      accountId: accountId,
      pointdeduct: pointsRequired,
      campaignId: campaignId
    };
    
    // Send webhook request
    const response = await fetch('https://metrosg.retool.com/url/redeem-voucher', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });
    
    const data = await response.json();
    
    if (response.ok) {
      console.log('Voucher redeemed successfully:', data);
      
      // Check if the message indicates successful redemption
      if (data && data.message === "Done redeem") {
        // Store flag to show success notification after page reload
        sessionStorage.setItem('voucherRedeemSuccess', 'true');
        // Set hash first, then force reload to ensure Safari mobile properly refreshes
        window.location.hash = "#vouchers";
        window.location.reload();
      } else {
        // Show error popup if message is not "Done redeem"
        console.error('Voucher redemption failed - invalid response:', data);
        const errorMessage = data?.message || data?.error || 'Failed to redeem voucher. Please check your voucher and try again.';
        showVoucherErrorNotification(errorMessage);
      }
    } else {
      console.error('Voucher redemption failed:', data);
      const errorMessage = data?.message || data?.error || 'Failed to redeem voucher. Please try again.';
      showVoucherErrorNotification(errorMessage);
    }
    
  } catch (error) {
    console.error('Error redeeming voucher:', error);
    showVoucherErrorNotification('An error occurred while redeeming the voucher. Please try again.');
  } finally {
    // Remove loading overlay
    const loadingOverlay = document.getElementById('voucher-loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.remove();
    }
  }
}

window.toggleOrderTabs = function(tab) {
  const onlineTab = document.querySelector('.order-tabs-container-item-title-online');
  const offlineTab = document.querySelector('.order-tabs-container-item-title-offline');
  const onlineContent = document.querySelector('.order-tabs-content-online');
  const offlineContent = document.querySelector('.order-tabs-content-offline');
  
  // Remove active class from all tabs and content
  onlineTab.classList.remove('active');
  offlineTab.classList.remove('active');
  onlineContent.classList.remove('active');
  offlineContent.classList.remove('active');
  
  // Add active class to selected tab and show corresponding content
  if (tab === 'online') {
    onlineTab.classList.add('active');
    onlineContent.classList.add('active');
  } else if (tab === 'offline') {
    offlineTab.classList.add('active');
    offlineContent.classList.add('active');
  }
}

window.togglePointsRedeem = function(evt) {
  if($('.points-redeem-button').hasClass('disabled')){
    return;
  }
  $('.points-redeem-container').show();
  $('.points-redeem-button').addClass('active');
  $('.points-transactions-container').hide();
  $('.points-load-more-btn').hide();
  $('.points-transactions-button').removeClass('active');
}

window.togglePointsTransactions = function() {
  $('.points-transactions-container').show();
  $('.points-load-more-btn').show();
  $('.points-transactions-button').addClass('active');
  $('.points-redeem-container').hide();
  $('.points-redeem-button').removeClass('active');
}

window.toggleVouchers = function(tab,evt) {
  const activeVouchers = document.querySelector('.vouchers-content-container.active-vouchers');
  const redeemedVouchers = document.querySelector('.vouchers-content-container.redeemed-vouchers');
  const expiredVouchers = document.querySelector('.vouchers-content-container.expired-vouchers');
  
  activeVouchers.classList.remove('active');
  redeemedVouchers.classList.remove('active');
  expiredVouchers.classList.remove('active');

  $('.vouchers-button').removeClass('active');
  $(evt).addClass('active');
  
  if (tab === 'active') {
    activeVouchers.classList.add('active');
  } else if (tab === 'redeemed') {
    redeemedVouchers.classList.add('active');
  } else if (tab === 'expired') {
    expiredVouchers.classList.add('active');
  }
}

// Voucher QR popup functionality
function initVoucherPopup() {
  // Create overlay element if it doesn't exist
  if ($('.voucher-code-qr-overlay').length === 0) {
    $('body').append('<div class="voucher-code-qr-overlay"></div>');
  }
  
  // Function to close all popups and overlay
  function closeAllPopups() {
    $('.voucher-code-qr-popup').hide();
    $('.voucher-code-qr-overlay').hide();
    $('#swym-plugin').show();
  }
  
  // Open popup when clicking on voucher-row-use-button
  $(document).on('click', '.voucher-row-use-button', function(e) {
    e.stopPropagation();
    
    // Close any other open popups first
    closeAllPopups();
    
    // Show overlay and popup
    $('#swym-plugin').hide();
    $('.voucher-code-qr-overlay').show();
    $(this).siblings('.voucher-code-qr-popup').show();

    //run wallet update webhook
    let email, walletId, significantLoginTime, significantTimestamp;
    
    // Get customer email from window.customerData if available
    if (window.customerData && window.customerData.hasValidData && window.customerData.email) {
      email = window.customerData.email;
      walletId = window.customerData.walletId || null;
      
      // Try to get significant login time from localStorage
      const loginTimeData = localStorage.getItem('customerLoginTime');
      if (loginTimeData) {
        try {
          const parsedData = JSON.parse(loginTimeData);
          significantLoginTime = parsedData.significantLoginTime || null;
          significantTimestamp = parsedData.significantTimestamp || null;
        } catch (parseError) {
          console.log('Could not parse login time data:', parseError);
        }
      }
      
      // Trigger webhook with available data after 10 seconds
      if (email) {
        setTimeout(function() {
          triggerWalletUpdateWebhook(email, walletId, significantLoginTime, significantTimestamp);
        }, 10000);
      }
    } else {
      console.log('No valid customer email available for wallet update webhook');
    }
  });
  
  // Close popup when clicking on cancel button
  $(document).on('click', '.voucher-code-qr-cancel', function(e) {
    e.stopPropagation();
    closeAllPopups();
  });
  
  // Close popup when clicking on overlay
  $(document).on('click', '.voucher-code-qr-overlay', function(e) {
    closeAllPopups();
  });
  
  // Prevent closing when clicking inside popup
  $(document).on('click', '.voucher-code-qr-popup', function(e) {
    e.stopPropagation();
  });
}

window.refreshLatestPoints = function() {
  console.log('refreshLatestPoints called');
  
  let email, walletId, significantLoginTime, significantTimestamp;
  
  // Get customer email and walletId from window.customerData if available
  if (window.customerData && window.customerData.hasValidData && window.customerData.email) {
    email = window.customerData.email;
    walletId = window.customerData.walletId || null;
    console.log('Using Liquid customer data for refresh');
  } else {
    // Fallback: Check localStorage for valid data
    const existingData = localStorage.getItem('customerLoginTime');
    if (existingData) {
      try {
        const parsedData = JSON.parse(existingData);
        if (parsedData.email) {
          email = parsedData.email;
          walletId = parsedData.walletId || null;
          console.log('Using localStorage customer data for refresh');
        }
      } catch (parseError) {
        console.log('Could not parse existing data for refresh:', parseError);
      }
    }
  }
  
  // Get significant login time from localStorage
  const loginTimeData = localStorage.getItem('customerLoginTime');
  if (loginTimeData) {
    try {
      const parsedData = JSON.parse(loginTimeData);
      significantLoginTime = parsedData.significantLoginTime || null;
      significantTimestamp = parsedData.significantTimestamp || null;
    } catch (parseError) {
      console.log('Could not parse login time data for refresh:', parseError);
    }
  }
  
  // Trigger webhooks if we have email
  if (email) {
    // Reset the flag so points balance webhook can be triggered again
    pointsBalanceWebhookTriggered = false;
    
    // Trigger both webhooks
    triggerPointsBalanceWebhook(email);
    triggerWalletUpdateWebhook(email, walletId, significantLoginTime, significantTimestamp);
  } else {
    console.log('No valid customer email available for refresh webhooks');
  }
}

/**
 * Handle minimuse button click - show/hide related divs based on block id
 * @param {string} blockId - The block id to show
 */
window.handleMinimuseButtonClick = function(blockId) {
  // Update button active state and get limit selection value
  var $allButtons = $('.button-list-minimuse');
  var limitSelection = '';
  
  $allButtons.each(function() {
    var $button = $(this);
    if ($button.attr('data-block-id') === blockId) {
      $button.addClass('active');
      // Get the limit selection value from the clicked button
      limitSelection = $button.attr('data-limit-selection') || '';
    } else {
      $button.removeClass('active');
    }
  });
  
  // Update limit-selection elements
  if (limitSelection) {
    $('.limit-selection').text(limitSelection);
  }
  
  // List of div classes to show/hide
  var divClasses = [
    'minimuse-paragraph',
    'collection-product-list',
    'tier-pouch-list',
    'tier-accessory-list'
  ];
  
  // Show/hide divs based on block id
  divClasses.forEach(function(className) {
    var $allDivs = $('.' + className);
    $allDivs.each(function() {
      var $div = $(this);
      if ($div.attr('data-block-id') === blockId) {
        $div.addClass('active');
      } else {
        $div.removeClass('active');
      }
    });
  });
  
  // Reset all sample buttons to "Add to Cart" when switching tiers
  resetAllSampleButtons();
  // Reset all pouch buttons to "Add to Cart" when switching tiers
  resetAllPouchButtons();
  // Update Add to Cart button state
  updateMinimuseAddToCartButton();
  
  // Initialize pagination after collection changes
  setTimeout(function() {
    initMinimusePagination();
  }, 100);
}

/**
 * Initialize minimuse product pagination
 * Shows 24 products per page with pagination controls
 */
function initMinimusePagination() {
  const PRODUCTS_PER_PAGE = 24;
  
  var $activeCollection = $('.collection-product-list.active');
  if ($activeCollection.length === 0) return;
  
  var $productItems = $activeCollection.find('.minimuse-product-item');
  var $paginationContainer = $activeCollection.find('.minimuse-pagination');
  var $pagesContainer = $activeCollection.find('.minimuse-pagination-pages');
  var $prevBtn = $activeCollection.find('.minimuse-pagination-prev');
  var $nextBtn = $activeCollection.find('.minimuse-pagination-next');
  
  if ($productItems.length === 0 || $paginationContainer.length === 0) return;
  
  var totalProducts = $productItems.length;
  var totalPages = Math.ceil(totalProducts / PRODUCTS_PER_PAGE);
  
  // Only show pagination if there are more than 24 products
  if (totalPages <= 1) {
    // Show all products if only one page
    $productItems.addClass('active');
    $paginationContainer.hide();
    return;
  }
  
  $paginationContainer.css('display', 'flex');
  var currentPage = 1;
  
  function showPage(page) {
    currentPage = page;
    var startIndex = (page - 1) * PRODUCTS_PER_PAGE;
    var endIndex = startIndex + PRODUCTS_PER_PAGE;
    
    // Hide all products
    $productItems.removeClass('active');
    
    // Show products for current page
    $productItems.slice(startIndex, endIndex).addClass('active');
    
    // Update pagination buttons
    $prevBtn.prop('disabled', page === 1);
    $nextBtn.prop('disabled', page === totalPages);
    
    // Update page numbers
    updatePageNumbers();
  }
  
  function updatePageNumbers() {
    $pagesContainer.empty();
    
    // Show page numbers with ellipsis if needed
    var startPage = Math.max(1, currentPage - 2);
    var endPage = Math.min(totalPages, currentPage + 2);
    
    if (startPage > 1) {
      var $firstPage = $('<span>').addClass('pagination__link subheading').text('1').css('cursor', 'pointer');
      $firstPage.on('click', function() { showPage(1); });
      $pagesContainer.append($firstPage);
      
      if (startPage > 2) {
        var $ellipsis = $('<span>').text('...').css('padding', '0 5px');
        $pagesContainer.append($ellipsis);
      }
    }
    
    for (var i = startPage; i <= endPage; i++) {
      var $pageBtn = $('<span>').addClass('pagination__link subheading').text(i).css('cursor', 'pointer');
      if (i === currentPage) {
        $pageBtn.attr('aria-current', 'page');
      }
      $pageBtn.on('click', function() {
        showPage(parseInt($(this).text()));
      });
      $pagesContainer.append($pageBtn);
    }
    
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        var $ellipsis = $('<span>').text('...').css('padding', '0 5px');
        $pagesContainer.append($ellipsis);
      }
      
      var $lastPage = $('<span>').addClass('pagination__link subheading').text(totalPages).css('cursor', 'pointer');
      $lastPage.on('click', function() { showPage(totalPages); });
      $pagesContainer.append($lastPage);
    }
  }
  
  // Remove existing event listeners by cloning buttons
  $prevBtn.off('click');
  $nextBtn.off('click');
  
  // Event listeners
  $prevBtn.on('click', function() {
    if (currentPage > 1) {
      showPage(currentPage - 1);
    }
  });
  
  $nextBtn.on('click', function() {
    if (currentPage < totalPages) {
      showPage(currentPage + 1);
    }
  });
  
  // Initialize first page
  showPage(1);
}

// Initialize pagination on page load
$(document).ready(function() {
  initMinimusePagination();
});

// Re-initialize pagination when collection changes (for dynamic button switching)
$(document).on('click', '.button-list-minimuse', function() {
  setTimeout(function() {
    initMinimusePagination();
  }, 300);
});

/**
 * Reset all sample buttons to "Add to Cart" text
 */
function resetAllSampleButtons() {
  $('.sample-button').each(function() {
    var $button = $(this);
    // Skip sold-out buttons - keep them as "Sold Out"
    if ($button.hasClass('sold-out-minimuse-product')) {
      return;
    }
    $button.removeClass('selected limit-reached');
    $button.html('Add to Cart');
  });
  // Reset the selected samples count display
  updateSelectedSamplesCount();
  // Update Add to Cart button state
  updateMinimuseAddToCartButton();
}

/**
 * Update the selected samples count display
 */
function updateSelectedSamplesCount() {
  var $activeCollection = $('.collection-product-list.active');
  var selectedCount = $activeCollection.find('.sample-button.selected').length;
  $('.selected-samples-count').text(selectedCount);
}

/**
 * Update sample button counts for non-selected buttons
 */
function updateSampleButtonCounts() {
  var $activeCollection = $('.collection-product-list.active');
  var $sampleButtons = $activeCollection.find('.sample-button');
  var selectedCount = $activeCollection.find('.sample-button.selected').length;
  var limitSelection = parseInt($('.button-list-minimuse.active').attr('data-limit-selection')) || 0;
  
  $sampleButtons.each(function() {
    var $button = $(this);
    // Skip sold-out buttons - keep them as "Sold Out"
    if ($button.hasClass('sold-out-minimuse-product')) {
      return;
    }
    if (!$button.hasClass('selected')) {
      // Only show count when limit is reached, otherwise show "Add to Cart"
      if (limitSelection > 0 && selectedCount >= limitSelection) {
        $button.html(selectedCount + ' samples selected').addClass('limit-reached');
      } else if (limitSelection === 0 && selectedCount > 0) {
        $button.html('no limit sample selected').removeClass('limit-reached');
      } else {
        $button.html('Add to Cart').removeClass('limit-reached');
      }
    }
  });
  
  // Update the selected samples count display
  updateSelectedSamplesCount();
  // Update Add to Cart button state
  updateMinimuseAddToCartButton();
}

/**
 * Handle sample button click
 * @param {HTMLElement} buttonElement - The button element that was clicked
 */
window.handleSampleButtonClick = function(buttonElement) {
  // Check if add to cart button has deny-add-to-cart class
  var $addToCartButton = $('.button-minimuse-add-to-cart');
  if ($addToCartButton.hasClass('deny-add-to-cart')) {
    return;
  }
  
  var $button = $(buttonElement);
  // Skip sold-out buttons - they shouldn't be clickable, but just in case
  if ($button.hasClass('sold-out-minimuse-product')) {
    return;
  }
  
  var $activeCollection = $('.collection-product-list.active');
  var limitSelection = parseInt($('.button-list-minimuse.active').attr('data-limit-selection')) || 0;
  var selectedCount = $activeCollection.find('.sample-button.selected').length;
  
  if ($button.hasClass('selected')) {
    // Remove selection
    $button.removeClass('selected');
    $button.html('Add to Cart');
    
    // Update count for all non-selected buttons
    updateSampleButtonCounts();
    // Update Add to Cart button state
    updateMinimuseAddToCartButton();
  } else {
    // Check if limit is reached
    if (limitSelection > 0 && selectedCount >= limitSelection) {
      // Limit reached, don't allow more selections
      return;
    }
    
    // Add selection
    $button.addClass('selected');
    
    // Get remove-bin icon HTML (using Liquid render syntax as reference)
    // Since we're in JS, we'll create the SVG directly
    var removeBinIcon = '<svg aria-hidden="true" focusable="false" width="16" class="icon icon-remove-bin" part="icon" viewBox="0 0 16 17" style="display: inline-block; vertical-align: middle; margin-left: 5px;"><path stroke="currentColor" fill="none" d="M2 4.5h12M3.5 4.5h9v10h-9v-10ZM6.5 7v5M9.5 7v5M5.5 4.5a2.5 2.5 0 1 1 5 0" /></svg>';
    $button.html('Remove' + removeBinIcon);
    
    // Update count for all non-selected buttons
    updateSampleButtonCounts();
    // Update Add to Cart button state
    updateMinimuseAddToCartButton();
    
    // Check if limit is reached after adding this selection
    var newSelectedCount = $activeCollection.find('.sample-button.selected').length;
    if (limitSelection > 0 && newSelectedCount >= limitSelection) {
      // Scroll to tier-pouch-container when limit is reached
      var $tierPouchContainer = $('.tier-pouch-container');
      if ($tierPouchContainer.length > 0) {
        $('html, body').animate({
          scrollTop: $tierPouchContainer.offset().top - 100
        }, 500);
      }
    }
  }
};

/**
 * Update pouch button text for non-selected buttons
 */
function updatePouchButtonTexts() {
  var $activeCollection = $('.tier-pouch-list.active');
  var $pouchButtons = $activeCollection.find('.pouch-button');
  var selectedCount = $activeCollection.find('.pouch-button.selected').length;
  
  $pouchButtons.each(function() {
    var $button = $(this);
    // Skip sold-out buttons - keep them as "Sold Out"
    if ($button.hasClass('sold-out-minimuse-product')) {
      return;
    }
    if (!$button.hasClass('selected')) {
      // If a pouch is selected, show "Pouch Selected" for non-selected buttons
      if (selectedCount > 0) {
        $button.html('Pouch Selected').addClass('limit-reached');
      } else {
        $button.html('Add to Cart').removeClass('limit-reached');
      }
    }
  });
  // Update Add to Cart button state
  updateMinimuseAddToCartButton();
}

/**
 * Reset all pouch buttons to "Add to Cart" text
 */
function resetAllPouchButtons() {
  $('.pouch-button').each(function() {
    var $button = $(this);
    // Skip sold-out buttons - keep them as "Sold Out"
    if ($button.hasClass('sold-out-minimuse-product')) {
      return;
    }
    $button.removeClass('selected limit-reached');
    $button.html('Add to Cart');
  });
}

/**
 * Handle pouch button click
 * Only 1 pouch can be selected at a time
 * @param {HTMLElement} buttonElement - The button element that was clicked
 */
window.handlePouchButtonClick = function(buttonElement) {
  // Check if add to cart button has deny-add-to-cart class
  var $addToCartButton = $('.button-minimuse-add-to-cart');
  if ($addToCartButton.hasClass('deny-add-to-cart')) {
    return;
  }
  
  var $button = $(buttonElement);
  // Skip sold-out buttons - they shouldn't be clickable, but just in case
  if ($button.hasClass('sold-out-minimuse-product')) {
    return;
  }
  
  var $activeCollection = $('.tier-pouch-list.active');
  
  // Check if product has multiple variants
  var hasMultipleVariants = $button.attr('data-has-multiple-variants') === 'true';
  
  if ($button.hasClass('selected')) {
    // Remove selection
    $button.removeClass('selected');
    $button.html('Add to Cart');
    
    // Update text for all non-selected buttons
    updatePouchButtonTexts();
    // Update Add to Cart button state
    updateMinimuseAddToCartButton();
    // Return early to prevent opening modal
    return;
  } else {
    // If product has multiple variants, open quick-buy-modal instead
    if (hasMultipleVariants) {
      var quickBuyId = $button.attr('aria-controls');
      if (quickBuyId) {
        var $quickBuyModal = $('#' + quickBuyId);
        if ($quickBuyModal.length > 0) {
          // Store reference to the button that opened the modal
          $quickBuyModal.attr('data-pouch-button-id', $button.attr('data-product-id'));
          // Open the modal
          if ($quickBuyModal[0] && typeof $quickBuyModal[0].show === 'function') {
            $quickBuyModal[0].show();
          } else {
            // Fallback: trigger click on modal if show method not available
            $quickBuyModal.trigger('click');
          }
        }
      }
      return;
    }
    
    // Single variant: directly select
    // Deselect all other pouch buttons first (only 1 can be selected)
    $activeCollection.find('.pouch-button').each(function() {
      var $otherButton = $(this);
      // Skip sold-out buttons - keep them as "Sold Out"
      if ($otherButton.hasClass('sold-out-minimuse-product')) {
        return;
      }
      if ($otherButton.hasClass('selected')) {
        $otherButton.removeClass('selected');
        $otherButton.html('Add to Cart');
      }
    });
    
    // Add selection to clicked button
    $button.addClass('selected');
    
    // Get remove-bin icon HTML
    var removeBinIcon = '<svg aria-hidden="true" focusable="false" width="16" class="icon icon-remove-bin" part="icon" viewBox="0 0 16 17" style="display: inline-block; vertical-align: middle; margin-left: 5px;"><path stroke="currentColor" fill="none" d="M2 4.5h12M3.5 4.5h9v10h-9v-10ZM6.5 7v5M9.5 7v5M5.5 4.5a2.5 2.5 0 1 1 5 0" /></svg>';
    $button.html('Remove' + removeBinIcon);
    
    // Update text for all non-selected buttons
    updatePouchButtonTexts();
    // Update Add to Cart button state
    updateMinimuseAddToCartButton();
  }
};

/**
 * Handle accessory button click
 * Similar to pouch button but allows multiple selections with quantity
 */
window.handleAccessoryButtonClick = function(buttonElement) {
  // Check if add to cart button has deny-add-to-cart class
  var $addToCartButton = $('.button-minimuse-add-to-cart');
  if ($addToCartButton.hasClass('deny-add-to-cart')) {
    return;
  }
  
  var $button = $(buttonElement);
  // Skip sold-out buttons - they shouldn't be clickable, but just in case
  if ($button.hasClass('sold-out-minimuse-product')) {
    return;
  }
  
  var $activeCollection = $('.tier-accessory-list.active');
  
  // Check if product has multiple variants
  var hasMultipleVariants = $button.attr('data-has-multiple-variants') === 'true';
  
  // Check if already selected
  if ($button.hasClass('selected')) {
    // Don't remove selection - just return (quantity is managed by quantity selector)
    return;
  }
  
  // If product has multiple variants, open quick-buy-modal instead
  if (hasMultipleVariants) {
    var quickBuyId = $button.attr('aria-controls');
    if (quickBuyId) {
      var $quickBuyModal = $('#' + quickBuyId);
      if ($quickBuyModal.length > 0) {
        // Store reference to the button that opened the modal
        $quickBuyModal.attr('data-accessory-button-id', $button.attr('data-product-id'));
        // Open the modal
        if ($quickBuyModal[0] && typeof $quickBuyModal[0].show === 'function') {
          $quickBuyModal[0].show();
        } else {
          // Fallback: trigger click on modal if show method not available
          $quickBuyModal.trigger('click');
        }
      }
    }
    return;
  }
  
  // Single variant: directly select with quantity 1
  selectAccessoryVariant($button, $button.attr('data-variant-id'), 1);
};

/**
 * Select an accessory variant (single or from modal)
 */
function selectAccessoryVariant($button, variantId, quantity) {
  var $activeCollection = $('.tier-accessory-list.active');
  
  // Add selection to clicked button
  $button.addClass('selected');
  $button.attr('data-variant-id', variantId);
  $button.attr('data-quantity', quantity || 1);
  
  // Update button UI with quantity selector
  updateAccessoryButtonUI($button, quantity || 1);
  
  // Update Add to Cart button state
  updateMinimuseAddToCartButton();
}

/**
 * Update accessory button UI to show quantity selector
 */
function updateAccessoryButtonUI($button, quantity) {
  quantity = quantity || 1;
  
  var quantitySelectorHTML = '<div class="accessory-quantity-selector h-stack gap-2 align-center">' +
    '<button type="button" class="accessory-quantity-decrease" aria-label="Decrease quantity">-</button>' +
    '<span class="accessory-quantity-value">' + quantity + '</span>' +
    '<button type="button" class="accessory-quantity-increase" aria-label="Increase quantity">+</button>' +
    '</div>';
  
  $button.html(quantitySelectorHTML);
  
  // Attach event handlers using jQuery for better reliability
  $button.find('.accessory-quantity-decrease').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    decreaseAccessoryQuantity(this, e);
    return false;
  });
  
  $button.find('.accessory-quantity-increase').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    increaseAccessoryQuantity(this, e);
    return false;
  });
}

/**
 * Decrease accessory quantity
 */
window.decreaseAccessoryQuantity = function(buttonElement, event) {
  // Prevent event propagation
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  // Find the accessory button - the decrease button is inside the accessory-button
  var $decreaseButton = $(buttonElement);
  var $button = $decreaseButton.closest('.accessory-button');
  
  // If not found via closest, try finding parent container
  if ($button.length === 0) {
    $button = $decreaseButton.closest('.accessory-button-container').find('.accessory-button');
  }
  
  if ($button.length === 0) {
    console.error('Accessory button not found');
    return false;
  }
  
  // Get current quantity from data attribute or from the displayed value
  var currentQuantity = parseInt($button.attr('data-quantity')) || 1;
  
  // Also try to get from the displayed value as fallback
  var displayedQuantity = parseInt($button.find('.accessory-quantity-value').text());
  if (!isNaN(displayedQuantity) && displayedQuantity > 0) {
    currentQuantity = displayedQuantity;
  }
  
  if (currentQuantity > 1) {
    // Decrease quantity
    currentQuantity--;
    $button.attr('data-quantity', currentQuantity);
    $button.find('.accessory-quantity-value').text(currentQuantity);
    updateMinimuseAddToCartButton();
  } else {
    // Remove selection if quantity is 1 (decrease to 0)
    $button.removeClass('selected');
    $button.removeAttr('data-quantity');
    // Keep variant ID and product ID for potential re-selection
    $button.html('Add to Cart');
    updateMinimuseAddToCartButton();
  }
  
  return false;
};

/**
 * Increase accessory quantity
 */
window.increaseAccessoryQuantity = function(buttonElement, event) {
  // Prevent event propagation
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  var $increaseButton = $(buttonElement);
  var $button = $increaseButton.closest('.accessory-button');
  
  // If not found via closest, try finding parent container
  if ($button.length === 0) {
    $button = $increaseButton.closest('.accessory-button-container').find('.accessory-button');
  }
  
  if ($button.length === 0) {
    console.error('Accessory button not found');
    return false;
  }
  
  // Get current quantity from data attribute or from the displayed value
  var currentQuantity = parseInt($button.attr('data-quantity')) || 1;
  
  // Also try to get from the displayed value as fallback
  var displayedQuantity = parseInt($button.find('.accessory-quantity-value').text());
  if (!isNaN(displayedQuantity) && displayedQuantity > 0) {
    currentQuantity = displayedQuantity;
  }
  
  currentQuantity++;
  $button.attr('data-quantity', currentQuantity);
  $button.find('.accessory-quantity-value').text(currentQuantity);
  
  updateMinimuseAddToCartButton();
  
  return false;
};

/**
 * Override quick-buy-modal show method for pouch selection
 * When data-pouch-selection is true, load pouch-quick-buy-content template instead of quick-buy-content
 */
(function() {
  function overrideQuickBuyModal() {
    if (window.customElements && window.customElements.get('quick-buy-modal')) {
      var QuickBuyModal = window.customElements.get('quick-buy-modal');
      
      // Check if already overridden
      if (QuickBuyModal.prototype._pouchOverrideApplied) {
        return;
      }
      
      var originalShow = QuickBuyModal.prototype.show;
      QuickBuyModal.prototype._pouchOverrideApplied = true;
      
      QuickBuyModal.prototype.show = function() {
        var self = this;
        
        if ((self.hasAttribute('data-pouch-selection') && self.getAttribute('data-pouch-selection') === 'true') ||
        (self.hasAttribute('data-accessory-selection') && self.getAttribute('data-accessory-selection') === 'true')) {
          // Override for pouch/accessory selection - use custom quick-buy-content template
          var showLoadingBar = self.controls.every(function(control) {
            return control.querySelector('button-content') === null;
          });
          
          var productUrl = self.getAttribute('product-url');
          
          // Check which type of selection this is before the Promise
          var isPouchSelection = self.hasAttribute('data-pouch-selection') && self.getAttribute('data-pouch-selection') === 'true';
          var isAccessorySelection = self.hasAttribute('data-accessory-selection') && self.getAttribute('data-accessory-selection') === 'true';
          
          [self, ...self.controls].forEach(function(control) {
            control.setAttribute('aria-busy', 'true');
          });
          
          var promise = new Promise(async function(resolve, reject) {
            try {
              if (showLoadingBar) {
                document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
              }
              
              // Use cachedFetch if available (from theme.js), otherwise use fetch
              var fetchFn = window.cachedFetch || fetch;
              var responseContent = await (await fetchFn(productUrl)).text();
              var tempDoc = new DOMParser().parseFromString(responseContent, 'text/html');
              
              // Check which type of selection this is and load the appropriate template
              
              var templateContent = null;
              
              if (isAccessorySelection) {
                // Load accessory quick-buy content
                var accessoryQuickBuyContent = tempDoc.getElementById('accessory-quick-buy-content');
                if (accessoryQuickBuyContent) {
                  templateContent = accessoryQuickBuyContent.content.cloneNode(true).firstElementChild;
                }
              } else if (isPouchSelection) {
                // Load pouch quick-buy content
                var pouchQuickBuyContent = tempDoc.getElementById('pouch-quick-buy-content');
                if (pouchQuickBuyContent) {
                  templateContent = pouchQuickBuyContent.content.cloneNode(true).firstElementChild;
                }
              }
              
              if (templateContent) {
                self.replaceChildren(templateContent);
              } else {
                // Fallback to regular quick-buy-content if custom content not found
                var quickBuyContent = tempDoc.getElementById('quick-buy-content');
                if (quickBuyContent) {
                  self.replaceChildren(quickBuyContent.content.cloneNode(true).firstElementChild);
                }
              }
              
              [self, ...self.controls].forEach(function(control) {
                control.setAttribute('aria-busy', 'false');
              });
              
              resolve();
              
              if (showLoadingBar) {
                document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
              }
            } catch (error) {
              console.error('Error loading quick buy content:', error);
              [self, ...self.controls].forEach(function(control) {
                control.setAttribute('aria-busy', 'false');
              });
              reject(error);
            }
          });
          
          // Call parent Modal's show method with our promise
          return Object.getPrototypeOf(Object.getPrototypeOf(self)).show.call(self, { conditionToFulfill: promise });
        } else {
          // Use original show method for regular quick-buy
          return originalShow.call(this);
        }
      };
    }
  }
  
  // Try immediately
  overrideQuickBuyModal();
  
  // Also try when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', overrideQuickBuyModal);
  }
  
  // Also try after a delay in case custom element is defined later
  setTimeout(overrideQuickBuyModal, 1000);
})();

/**
 * Intercept quick-buy-modal form submission for accessory selection
 * When quick-buy-modal is opened from tier-accessory-list, it should select variant instead of adding to cart
 */
$(document).on('dialog:after-show', 'quick-buy-modal[data-accessory-selection="true"]', function() {
  var $modal = $(this);
  var productId = $modal.attr('data-accessory-button-id');
  
  // Ensure accessory-select-button custom element is initialized
  // The custom element should handle the selection, but we can also add a fallback
  setTimeout(function() {
    var $accessorySelectButton = $modal.find('accessory-select-button');
    if ($accessorySelectButton.length > 0) {
      // Custom element should be initialized by now
      console.log('Accessory select button found in modal');
    }
  }, 200);
});

/**
 * Intercept quick-buy-modal form submission for pouch selection
 * When quick-buy-modal is opened from tier-pouch-list, it should select variant instead of adding to cart
 */
$(document).on('dialog:after-show', 'quick-buy-modal[data-pouch-selection="true"]', function() {
  var $modal = $(this);
  var productId = $modal.attr('data-pouch-button-id');
  var modalElement = this;
  
  // Use MutationObserver to watch for form being added to modal
  var observer = new MutationObserver(function(mutations) {
    var $form = $modal.find('form[action*="/cart/add"], product-form form');
    if ($form.length > 0) {
      observer.disconnect();
      setupPouchQuickBuyForm($modal, productId, modalElement);
    }
  });
  
  // Start observing
  observer.observe(modalElement, {
    childList: true,
    subtree: true
  });
  
  // Also try immediately in case form is already there
  setTimeout(function() {
    var $form = $modal.find('form[action*="/cart/add"], product-form form');
    if ($form.length > 0) {
      observer.disconnect();
      setupPouchQuickBuyForm($modal, productId, modalElement);
    }
  }, 100);
  
  // Fallback: try again after a delay
  setTimeout(function() {
    observer.disconnect();
    var $form = $modal.find('form[action*="/cart/add"], product-form form');
    if ($form.length > 0) {
      setupPouchQuickBuyForm($modal, productId, modalElement);
    }
  }, 1000);
});

// Global document-level listener for form submissions in pouch-selection modals
$(document).on('submit', 'quick-buy-modal[data-pouch-selection="true"] form', function(e) {
  var $form = $(this);
  var $modal = $form.closest('quick-buy-modal[data-pouch-selection="true"]');
  var productId = $modal.attr('data-pouch-button-id');
  
  if (productId && $modal.length > 0) {
    e.preventDefault();
    e.stopPropagation();
    handlePouchVariantSelection($modal, productId, $modal[0]);
    return false;
  }
});

// Global document-level listener for pouch-select-button clicks (fallback)
$(document).on('click', 'quick-buy-modal[data-pouch-selection="true"] pouch-select-button button', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  var $clickedButton = $(this);
  var $pouchSelectButton = $clickedButton.closest('pouch-select-button');
  var $modal = $pouchSelectButton.closest('quick-buy-modal[data-pouch-selection="true"]');
  
  if ($modal.length === 0) {
    return false;
  }
  
  var productId = $modal.attr('data-pouch-button-id');
  if (!productId) {
    console.error('Product ID not found on modal');
    return false;
  }
  
  var formId = $pouchSelectButton.attr('form');
  var $form = $('#' + formId);
  
  if ($form.length === 0) {
    $form = $pouchSelectButton.closest('form');
  }
  
  // Also try to find form inside product-form
  if ($form.length === 0) {
    var $productForm = $pouchSelectButton.closest('product-form');
    if ($productForm.length > 0) {
      $form = $productForm.find('form');
    }
  }
  
  var variantId = $form.find('input[name="id"]').val();
  
  // If variant ID not found, try to get it from product-form
  if (!variantId) {
    var $productForm = $form.closest('product-form');
    if ($productForm.length > 0) {
      variantId = $productForm.find('input[name="id"]').val();
    }
  }
  
  if (!variantId) {
    console.error('Variant ID not found in form');
    return false;
  }
  
  // Handle the selection
  handlePouchVariantSelection($modal, productId, $modal[0], variantId);
  
  return false;
});

// Global document-level listener for accessory-select-button clicks (fallback)
$(document).on('click', 'quick-buy-modal[data-accessory-selection="true"] accessory-select-button button', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  var $clickedButton = $(this);
  var $accessorySelectButton = $clickedButton.closest('accessory-select-button');
  var $modal = $accessorySelectButton.closest('quick-buy-modal[data-accessory-selection="true"]');
  
  if ($modal.length === 0) {
    return false;
  }
  
  var productId = $modal.attr('data-accessory-button-id');
  if (!productId) {
    console.error('Product ID not found on modal');
    return false;
  }
  
  var formId = $accessorySelectButton.attr('form');
  var $form = $('#' + formId);
  
  if ($form.length === 0) {
    $form = $accessorySelectButton.closest('form');
  }
  
  // Also try to find form inside product-form
  if ($form.length === 0) {
    var $productForm = $accessorySelectButton.closest('product-form');
    if ($productForm.length > 0) {
      $form = $productForm.find('form');
    }
  }
  
  var variantId = $form.find('input[name="id"]').val();
  
  // If variant ID not found, try to get it from product-form
  if (!variantId) {
    var $productForm = $form.closest('product-form');
    if ($productForm.length > 0) {
      variantId = $productForm.find('input[name="id"]').val();
    }
  }
  
  if (!variantId) {
    console.error('Variant ID not found in form');
    return false;
  }
  
  // Find the accessory button
  var $activeAccessoryList = $('.tier-accessory-list.active');
  var $accessoryButton = $activeAccessoryList.find('.accessory-button[data-product-id="' + productId + '"]');
  
  if ($accessoryButton.length === 0) {
    console.error('Accessory button not found for product ID:', productId);
    return false;
  }
  
  // Select the variant with quantity 1
  selectAccessoryVariant($accessoryButton, variantId, 1);
  
  // Close the modal
  if ($modal[0] && typeof $modal[0].hide === 'function') {
    $modal[0].hide();
  } else {
    $modal.removeAttr('open');
    $modal.attr('aria-hidden', 'true');
  }
  
  return false;
});

/**
 * Custom element for pouch select button
 * Handles variant selection instead of adding to cart
 */
(function() {
  if (!window.customElements.get('pouch-select-button')) {
    class PouchSelectButton extends HTMLElement {
      connectedCallback() {
        var self = this;
        var formId = this.getAttribute('form');
        
        // Wait a bit for content to be fully rendered
        setTimeout(function() {
          var $button = $(self).find('button');
          
          if ($button.length === 0) {
            $button = $(self).find('[type="button"]');
          }
          
          if ($button.length === 0) {
            console.error('Button not found in pouch-select-button');
            return;
          }
          
          // Handle button click
          $button.off('click.pouch-select').on('click.pouch-select', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Get the modal
            var $modal = $(self).closest('quick-buy-modal[data-pouch-selection="true"]');
            if ($modal.length === 0) {
              console.error('Pouch select button not inside pouch-selection modal');
              return false;
            }
            
            var productId = $modal.attr('data-pouch-button-id');
            if (!productId) {
              console.error('Product ID not found on modal');
              return false;
            }
            
            // Get the selected variant ID from the form
            var $form = $('#' + formId);
            if ($form.length === 0) {
              $form = $(self).closest('form');
            }
            
            // Also try to find form inside product-form
            if ($form.length === 0) {
              var $productForm = $(self).closest('product-form');
              if ($productForm.length > 0) {
                $form = $productForm.find('form');
              }
            }
            
            var variantId = $form.find('input[name="id"]').val();
            
            // If variant ID not found, try to get it from product-form
            if (!variantId) {
              var $productForm = $form.closest('product-form');
              if ($productForm.length > 0) {
                variantId = $productForm.find('input[name="id"]').val();
              }
            }
            
            if (!variantId) {
              console.error('Variant ID not found in form. Form ID:', formId, 'Form:', $form.length);
              return false;
            }
            
            // Handle the selection
            handlePouchVariantSelection($modal, productId, $modal[0], variantId);
            
            return false;
          });
        }, 100);
      }
    }
    
    window.customElements.define('pouch-select-button', PouchSelectButton);
  }
})();

/**
 * Custom element for accessory select button
 * This is just a wrapper element - the actual click handling is done via onclick handler
 * Kept for structure but primary functionality is in handleAccessorySelectButtonClick
 */
(function() {
  if (!window.customElements.get('accessory-select-button')) {
    class AccessorySelectButton extends HTMLElement {
      connectedCallback() {
        // The onclick handler on the button itself handles the click
        // This custom element is just a wrapper for structure
        // No additional setup needed as onclick handles everything
      }
    }
    
    window.customElements.define('accessory-select-button', AccessorySelectButton);
  }
})();

function setupPouchQuickBuyForm($modal, productId, modalElement) {
  // Find form - could be direct form or inside product-form custom element
  var $form = $modal.find('form[action*="/cart/add"]');
  var $productForm = $modal.find('product-form');
  
  // If we have a product-form custom element, intercept its submit
  if ($productForm.length > 0) {
    $productForm.off('submit.pouch-selection').on('submit.pouch-selection', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handlePouchVariantSelection($modal, productId, modalElement);
      return false;
    });
    
    // Also intercept the form inside product-form
    var $innerForm = $productForm.find('form');
    if ($innerForm.length > 0) {
      $innerForm.off('submit.pouch-selection').on('submit.pouch-selection', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handlePouchVariantSelection($modal, productId, modalElement);
        return false;
      });
    }
  }
  
  // Also intercept direct form submission
  if ($form.length > 0) {
    $form.off('submit.pouch-selection').on('submit.pouch-selection', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handlePouchVariantSelection($modal, productId, modalElement);
      return false;
    });
  }
  
  // Intercept at document level for product-form custom element events (using event delegation)
  // This is set up once globally, not per modal instance
}

/**
 * Handle accessory select button click (called from onclick)
 */
window.handleAccessorySelectButtonClick = function(buttonElement, formId) {
  var $button = $(buttonElement);
  var $accessorySelectButton = $button.closest('accessory-select-button');
  var $modal = $accessorySelectButton.closest('quick-buy-modal[data-accessory-selection="true"]');
  
  if ($modal.length === 0) {
    console.error('Accessory select button not inside accessory-selection modal');
    return false;
  }
  
  var productId = $modal.attr('data-accessory-button-id');
  if (!productId) {
    console.error('Product ID not found on modal');
    return false;
  }
  
  // Get the selected variant ID from the form
  var $form = $('#' + formId);
  if ($form.length === 0) {
    $form = $accessorySelectButton.closest('form');
  }
  
  // Also try to find form inside product-form
  if ($form.length === 0) {
    var $productForm = $accessorySelectButton.closest('product-form');
    if ($productForm.length > 0) {
      $form = $productForm.find('form');
    }
  }
  
  var variantId = $form.find('input[name="id"]').val();
  
  // If variant ID not found, try to get it from product-form
  if (!variantId) {
    var $productForm = $form.closest('product-form');
    if ($productForm.length > 0) {
      variantId = $productForm.find('input[name="id"]').val();
    }
  }
  
  if (!variantId) {
    console.error('Variant ID not found in form. Form ID:', formId, 'Form:', $form.length);
    return false;
  }
  
  // Find the accessory button
  var $activeAccessoryList = $('.tier-accessory-list.active');
  var $accessoryButton = $activeAccessoryList.find('.accessory-button[data-product-id="' + productId + '"]');
  
  if ($accessoryButton.length === 0) {
    console.error('Accessory button not found for product ID:', productId);
    return false;
  }
  
  // Select the variant with quantity 1
  selectAccessoryVariant($accessoryButton, variantId, 1);
  
  // Close the modal
  if ($modal[0] && typeof $modal[0].hide === 'function') {
    $modal[0].hide();
  } else {
    $modal.removeAttr('open');
    $modal.attr('aria-hidden', 'true');
  }
  
  return false;
};

/**
 * Handle pouch select button click (called from onclick) - keeping for backward compatibility
 */
window.handlePouchSelectButtonClick = function(buttonElement, formId) {
  var $button = $(buttonElement);
  var $pouchSelectButton = $button.closest('pouch-select-button');
  var $modal = $pouchSelectButton.closest('quick-buy-modal[data-pouch-selection="true"]');
  
  if ($modal.length === 0) {
    console.error('Pouch select button not inside pouch-selection modal');
    return false;
  }
  
  var productId = $modal.attr('data-pouch-button-id');
  if (!productId) {
    console.error('Product ID not found on modal');
    return false;
  }
  
  // Get the selected variant ID from the form
  var $form = $('#' + formId);
  if ($form.length === 0) {
    $form = $pouchSelectButton.closest('form');
  }
  
  // Also try to find form inside product-form
  if ($form.length === 0) {
    var $productForm = $pouchSelectButton.closest('product-form');
    if ($productForm.length > 0) {
      $form = $productForm.find('form');
    }
  }
  
  var variantId = $form.find('input[name="id"]').val();
  
  // If variant ID not found, try to get it from product-form
  if (!variantId) {
    var $productForm = $form.closest('product-form');
    if ($productForm.length > 0) {
      variantId = $productForm.find('input[name="id"]').val();
    }
  }
  
  if (!variantId) {
    console.error('Variant ID not found in form. Form ID:', formId, 'Form:', $form.length);
    return false;
  }
  
  // Handle the selection
  handlePouchVariantSelection($modal, productId, $modal[0], variantId);
  
  return false;
};

function handlePouchVariantSelection($modal, productId, modalElement, variantId) {
  // Get the selected variant ID from the form if not provided
  if (!variantId) {
    var $form = $modal.find('form[action*="/cart/add"], product-form form');
    variantId = $form.find('input[name="id"]').val();
    
    // If variant ID not found, try to get it from product-form
    if (!variantId) {
      var $productForm = $modal.find('product-form');
      if ($productForm.length > 0) {
        variantId = $productForm.find('input[name="id"]').val();
      }
    }
  }
  
  if (!variantId) {
    console.error('Variant ID not found in form');
    return false;
  }
  
  // Find the corresponding pouch button
  var $activePouchList = $('.tier-pouch-list.active');
  var $pouchButton = $activePouchList.find('.pouch-button[data-product-id="' + productId + '"]');
  
  if ($pouchButton.length === 0) {
    console.error('Pouch button not found for product ID:', productId);
    return false;
  }
  
  // Update the variant ID on the button
  $pouchButton.attr('data-variant-id', variantId);
  
  // Deselect all other pouch buttons first (only 1 can be selected)
  $activePouchList.find('.pouch-button').each(function() {
    var $otherButton = $(this);
    // Skip sold-out buttons - keep them as "Sold Out"
    if ($otherButton.hasClass('sold-out-minimuse-product')) {
      return;
    }
    if ($otherButton.hasClass('selected')) {
      $otherButton.removeClass('selected');
      $otherButton.html('Add to Cart');
    }
  });
  
  // Add selection to the pouch button
  $pouchButton.addClass('selected');
  
  // Get remove-bin icon HTML
  var removeBinIcon = '<svg aria-hidden="true" focusable="false" width="16" class="icon icon-remove-bin" part="icon" viewBox="0 0 16 17" style="display: inline-block; vertical-align: middle; margin-left: 5px;"><path stroke="currentColor" fill="none" d="M2 4.5h12M3.5 4.5h9v10h-9v-10ZM6.5 7v5M9.5 7v5M5.5 4.5a2.5 2.5 0 1 1 5 0" /></svg>';
  $pouchButton.html('Remove' + removeBinIcon);
  
  // Update text for all non-selected buttons
  updatePouchButtonTexts();
  // Update Add to Cart button state
  updateMinimuseAddToCartButton();
  
  // Close the modal
  if (modalElement && typeof modalElement.hide === 'function') {
    modalElement.hide();
  } else {
    $modal.removeAttr('open');
    $modal.attr('aria-hidden', 'true');
  }
  
  return false;
}

/**
 * Update the Add to Cart button state based on sample limit and pouch selection
 * Button is enabled when: sample limit is reached AND 1 pouch is selected
 */
function updateMinimuseAddToCartButton() {
  var $addToCartButton = $('.button-minimuse-add-to-cart');
  var $activeCollection = $('.collection-product-list.active');
  var $activePouchList = $('.tier-pouch-list.active');
  var $activeTierButton = $('.button-list-minimuse.active');
  
  // Get the limit selection value
  var limitSelection = parseInt($activeTierButton.attr('data-limit-selection')) || 0;
  
  // Count selected samples
  var selectedSamplesCount = $activeCollection.find('.sample-button.selected').length;
  
  // Check if 1 pouch is selected
  var selectedPouchCount = $activePouchList.find('.pouch-button.selected').length;
  var isPouchSelected = selectedPouchCount === 1;
  
  // Check if sample limit is reached
  var isSampleLimitReached = false;
  if (limitSelection > 0) {
    // If there's a limit, check if it's reached
    isSampleLimitReached = selectedSamplesCount >= limitSelection;
  } else {
    // If limit is 0 or no limit, require at least 1 sample
    isSampleLimitReached = selectedSamplesCount > 0;
  }
  
  // Enable button if both conditions are met, otherwise disable
  if (isSampleLimitReached && isPouchSelected) {
    $addToCartButton.removeClass('disabled');
  } else {
    $addToCartButton.addClass('disabled');
  }
}

/**
 * Add pouch and samples to cart using cart/add.js API
 * Main product is added first, then samples and pouch are added with parent_id
 */
window.addMinimuseItemsToCart = function() {
  // Check if button is disabled or has deny-add-to-cart class
  var $addToCartButton = $('.button-minimuse-add-to-cart');
  if ($addToCartButton.hasClass('disabled') || $addToCartButton.hasClass('deny-add-to-cart')) {
    return;
  }
  
  // Get the section ID for faster rerender
  var $minimuseContainer = $('.minimuse-product-main-container');
  var sectionElement = $minimuseContainer.length > 0 ? $minimuseContainer.closest('.shopify-section')[0] : null;
  var sectionId = sectionElement ? sectionElement.id.replace('shopify-section-', '') : null;
  
  // Show loading overlay
  function showLoadingOverlay() {
    var $overlay = $('#minimuse-loading-overlay');
    if ($overlay.length === 0) {
      // Create overlay if it doesn't exist
      var overlay = document.createElement('div');
      overlay.id = 'minimuse-loading-overlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; align-items: center; justify-content: center; pointer-events: auto;';
      overlay.innerHTML = '<div style="background: white; padding: 30px 40px; border-radius: 8px; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.3);"><div style="border: 4px solid #f3f3f3; border-top: 4px solid #333; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto 15px;"></div><div style="font-size: 16px; color: #333; font-weight: 500;">Adding to cart...</div></div>';
      
      // Add spin animation if not already in style
      if (!document.getElementById('minimuse-spin-style')) {
        var style = document.createElement('style');
        style.id = 'minimuse-spin-style';
        style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
        document.head.appendChild(style);
      }
      
      document.body.appendChild(overlay);
    } else {
      // Ensure overlay is visible
      $overlay.css({
        'display': 'flex',
        'visibility': 'visible',
        'opacity': '1'
      }).show();
    }
  }
  
  // Hide loading overlay
  function hideLoadingOverlay() {
    var $overlay = $('#minimuse-loading-overlay');
    if ($overlay.length > 0) {
      $overlay.hide();
    }
  }
  
  // Show overlay immediately
  showLoadingOverlay();
  
  // Get the main variant ID from the active tier button (pouch becomes the main variant)
  var $activeTierButton = $('.tier-pouch-list.active');
  var $selectedPouch = $activeTierButton.find('.pouch-button.selected');
  var mainVariantId = $selectedPouch.attr('data-variant-id');
  
  if (!mainVariantId) {
    console.error('Error: Main variant ID (pouch) not found');
    hideLoadingOverlay();
    return;
  }
  
  // Generate bindId with timestamp in seconds
  var timestampSeconds = Math.floor(Date.now() / 1000);
  var bindId = mainVariantId.toString() + '_' + timestampSeconds;
  
  // Build items array - start with main product
  var items = [
    { id: parseInt(mainVariantId), quantity: 1, properties: {'_minimuse_parent': 'Yes', '_bindId': bindId} }
  ];
  
  // Get all selected sample buttons from the active collection
  var $activeCollection = $('.collection-product-list.active');
  var $selectedSamples = $activeCollection.find('.sample-button.selected');
  
  // Add each selected sample with parent_id
  $selectedSamples.each(function() {
    var $button = $(this);
    var variantId = $button.attr('data-variant-id');
    if (variantId) {
      items.push({
        id: parseInt(variantId),
        quantity: 1,
        properties: {'_minimuse_child': 'Yes', '_bindId': bindId},
        parent_id: parseInt(mainVariantId)
      });
    }
  });
  
  /*
  // Get selected pouch button from the active pouch list
  var $activePouchList = $('.tier-pouch-list.active');
  var $selectedPouch = $activePouchList.find('.pouch-button.selected');
  
  // Add selected pouch with parent_id
  if ($selectedPouch.length > 0) {
    var pouchVariantId = $selectedPouch.attr('data-variant-id');
    if (pouchVariantId) {
      items.push({
        id: parseInt(pouchVariantId),
        quantity: 1
      });
    }
  }
  */
  
  // Get selected accessory buttons from the active accessory list
  var $activeAccessoryList = $('.tier-accessory-list.active');
  var $selectedAccessories = $activeAccessoryList.find('.accessory-button.selected');
  
  // Add each selected accessory with parent_id and quantity
  $selectedAccessories.each(function() {
    var $button = $(this);
    var variantId = $button.attr('data-variant-id');
    var quantity = parseInt($button.attr('data-quantity')) || 1;
    
    if (variantId) {
      items.push({
        id: parseInt(variantId),
        quantity: quantity
      });
    }
  });
  
  // Build cart/add.js request with sections parameter for faster rerender
  var requestBody = {
    items: items
  };
  
  // Add sections parameter if section ID is available to get section HTML in response
  if (sectionId) {
    requestBody.sections = sectionId;
  }
  
  // Call the cart/add.js API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Items added to cart:', data);
    
    // Rerender the minimuse section to update pouchselected state
    // Use section HTML from response if available (much faster)
    if (typeof window.rerenderMinimuseSection === 'function') {
      if (data.sections && data.sections[sectionId]) {
        // Use section HTML directly from response (fastest)
        window.rerenderMinimuseSection(data.sections[sectionId]);
      } else {
        // Fallback to fetching section HTML
        window.rerenderMinimuseSection();
      }
    }
    
    // Hide loading overlay
    hideLoadingOverlay();
    
    // Trigger cart drawer refresh
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      // Dispatch cart:refresh event to rerender cart drawer
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      
      // Wait for cart drawer to be refreshed before opening
      var openCartDrawer = function() {
        // Try the cart-drawer custom element first
        var cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.show();
        } else {
          // Fallback to jQuery selector
          var $cartDrawer = $('#cart-drawer')[0];
          if ($cartDrawer && !$cartDrawer.hasAttribute('open')) {
            $cartDrawer.show();
          }
        }
      };
      
      // Listen for cart drawer refresh completion
      var refreshHandler = function() {
        openCartDrawer();
        document.documentElement.removeEventListener('cart-drawer:refreshed', refreshHandler);
      };
      document.documentElement.addEventListener('cart-drawer:refreshed', refreshHandler);
      
      // Fallback: if cart-drawer:refreshed doesn't fire within 1 second, open anyway
      setTimeout(function() {
        document.documentElement.removeEventListener('cart-drawer:refreshed', refreshHandler);
        openCartDrawer();
      }, 1000);
    }
  })
  .catch(error => {
    console.error('Error adding items to cart:', error);
    // Hide loading overlay on error
    hideLoadingOverlay();
  });
};